export const menuData = [
  {
    category: 'Азійська кухня',
    subcategories: [{
        subcategory: 'Поке-боули',
        items: [
          {
            id: 1,
            title: 'Поке-боул з лососем 320г',
            price: '290 грн',
            src: require('../img/boulLososNew.jpg'),
            text: 'Рис, лосось, авокадо, огірок, Чука, редька дайкон, кунжут, соус манго, соус спайсі, норі',
            zvd: 'room',
          },
          {
            id: 2,
            title: 'Поке-боул з креветкою 320г',
            price: '290 грн',
            src: require('../img/boulKrevetkaTigr.jpg'),
            text: 'Рис, креветка тигрова, перець червоний, чука, манго, огірок, кунжут, соус манго, соус солодкий чилі, норі',
            zvd: 'room',
          },

          {
            id: 3,
            title: 'Поке-боул з тунцем 320г',
            price: '290 грн',
            src: require('../img/boulTunec.jpg'),
            text: 'Рис, тунець, редька дайкон, чука, томат черрі, огірок, кунжут, соус манго, соус унагі, норі',
            zvd: 'room',
          },
        ],
      },
      {
        subcategory: 'Салати з чука',
        items: [
          // {
          //   id: 1,
          //   title: '«Чука» салат з вугрем 230г',
          //   price: '189 грн',
          //   src: require('../img/chukaugor.jpg'),
          //   text: 'чука, вугор, соэвий соус, кунжут',
          //   zvd: 'room',
          // },
          // {
          //   id: 2,
          //   title: '«Чука» салат з лососем 230г',
          //   price: '179 грн',
          //   src: require('../img/chukalos.jpg'),
          //   text: 'чука, лосось, соэвий соус, кунжут',
          //   zvd: 'room',
          // },

          // {
          //   id: 3,
          //   title: '«Чука» салат з креветками 190г',
          //   price: '175 грн',
          //   src: require('../img/chukakrevetka.jpg'),
          //   text: 'чука, креветки, соэвий соус, кунжут',
          //   zvd: 'orangery',
          // },
          {
            id: 4,
            title: '«Чука» салат з горіховим соусом  180г',
            price: '189 грн',
            src: require('../img/chukasous.jpg'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
        ],
      },
      {
        subcategory: 'Авторські роли',
        items: [
          {
            id: 1,
            title: 'Пряний рол 250 г',
            // isNew: true,
            price: '340 грн',
            src: require('../img/Pryaniyrol.jpg'),
            text: 'Груша, гарбуз, крем-сир, вугор, соус манго, насіння гарбуза',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //   id: 2,
          //   title: 'Black & White 300г',
          //   isNew: true,
          //   price: '429 грн',
          //   src: require('../img/BlackandWhite.jpg'),
          //   text: 'РИС, КРЕМ-СИР, ФИЛЕ МАСЛЯНОЇ РИБИ, МАРИНОВАНА РЕДЬКА, ОГІРОК, ЧОРНИЛА КАРАКАТИЦІ, ВУГОР',
          //   zvd: 'room',
          // },
          {
            id: 3,
            title: 'Рол «Грін» (гострий) 290г',
            // isNew: true,
            price: '350 грн',
            src: require('../img/rolgreen.jpg'),
            text: 'норі, рис, огірок, крем-сир, лосось, тунець, авокадо, соус спайсі',
            zvd: 'room',
            energy: true,
          },
          // {
          //     id:4,
          //     title:"Рол Orange 300г",
          //     isNew: true,
          //     price:"350 грн",
          //     src: require('../img/rolorange.jpg'),
          //     text:"норі, рис, крем-сир, лосось, вугор, апельсин, соус унагі, соус солодкий чілі, кунжут",
          // zvd: 'orangery',},
          // {
          //     id:5,
          //     title:"Рол Крабс 250г",
          //     isNew: true,
          //     price:"265 грн",
          //     src: require('../img/rolkarabas.jpg'),
          //     text:"норі, рис, авокадо, крабовий крем,ікра масага",
          // zvd: 'orangery',},
          // {
          //     id:6,
          //     title:"Рол «Інь-янь» 260г",
          //     isNew: true,
          //     price:"300 грн",
          //     src: require('../img/inyan.jpg'),
          //     text:"норі, рис, огірок, ікра масага, вугор, кунжут, крем-сир, соус унагі",
          // zvd: 'orangery',},
          // {
          //     id:7,
          //     title:"Рол з манго та креветкою 265г",
          //     isNew: true,
          //     price:"330 грн",
          //     src: require('../img/rolmango.jpg'),
          //     text:"норі, рис, крем-сир, манго, ікра масага, тигрова креветка, Унагі",
          // zvd: 'orangery',},
          // {
          //     id:8,
          //     title:"Опалений рол з манго 290г",
          //     isNew: true,
          //     price:"328 грн",
          //     src: require('../img/obpflvango.jpg'),
          //     text:"норі, рис, крем-сир, лосось, манго, ікра масага",
          // zvd: 'orangery',},
          {
            id: 9,
            title: 'Фірмовий рол «Оранжерея» 270г',
            price: '379 грн',
            src: require('../img/orangereya.jpg'),
            text: 'норі, рис, крем-сир, лосось, огірок, ікорний продукт, «чука», горіховий соус',
            zvd: 'room',
            energy: true,
          },
          // {
          //     id:10,
          //     title:"«Гейша» 280г",
          //     price:"300 грн",
          //     src:require('../img/geysha.jpg'),
          //     text:"норі, рис, креветка, крем-сир, ікорний продукт, огірок, крабовий крем",
          // zvd: 'orangery',},
          {
            id: 11,
            title: 'Рол з обпаленим лососем 290г',
            price: '400 грн',
            src: require('../img/rolobplas.jpg'),
            text: 'рис, авокадо, соус спайсі, нитки Чилі, огірок, лосось, норі ',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:12,
          //     title:"Рол «Кімамі» (гострий) 250г",
          //     price:"279 грн",
          //     src:require('../img/kimami.jpg'),
          //     text:"рис, лосось, авокадо, огірок, соус спайс, соус шрірача, кунжут, норі ",
          // zvd: 'orangery',},
          // {
          //     id:13,
          //     title:"Рол «Asama» 300г",
          //     price:"299 грн",
          //     src:require('../img/asama.jpg'),
          //     text:"рис, крабовий крем, ананас, лосось, норі, арахіс",
          // zvd: 'orangery',},
          // {
          //   id: 14,
          //   title: 'Рол «Yoko» 320г',
          //   price: '349 грн',
          //   src: require('../img/yokko.jpg'),
          //   text: 'рис, крем-сир, вугор, огірок, авокадо, манго, соус унагі, пластівці мигдальні, норі ',
          //   zvd: 'orangery',
          // },
        ],
      },
      {
        subcategory: 'Чіз-роли',
        items: [
          {
            id: 5,
            title: 'ЧІЗ РОЛ З МІДІЄЮ 270г',
            price: '289 грн',
            isNew: true,
            src: require('../img/cheaseMidia.jpg'),
            text: 'РИС, КРЕМ-СИР, МЯСО МІДІЇ, САЛАТ ЧУКА, ОГІРОК, ЧЕДДЕР, соус унагі, нитки Чилі',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 4,
            title: 'Чіз рол з тунцем 270г',
            price: '330 грн',
            // isNew: true,
            src: require('../img/sirLosos.jpg'),
            text: 'рис, крем-сир, огірок, тунець, чеддер, соус вишневий, мигдальні пластівці',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 1,
            title: 'Чіз рол з тигровою креветкою 270г',

            price: '320 грн',
            src: require('../img/cheezrol.jpg'),
            text: 'норі, рис, крем-сир, сир чеддер, тигрова креветка, авокадо, Унагі, соус манго, мікрогрін',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 2,
            title: 'Чіз рол з креветками 270г',
            price: '320 грн',
            src: require('../img/sirKrev.jpg'),
            text: 'рис, крем-сир, авокадо, креветка, чеддер',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 3,
            title: 'Чіз рол з лососем 270г',
            price: '350 грн',
            src: require('../img/sirLosos.jpg'),
            text: 'рис, крем-сир, огірок, лосось, чеддер, соус вишневий, мигдальні пластівці',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:4,
          //     title:"Чіз рол 245г",
          //     isNew: true,
          //     price:"260 грн",
          //     src: require('../img/rolcheder.jpg'),
          //     text:"норі, рис, крем-сир, сир чеддер, соус унаги",
          // zvd: 'orangery',},
        ],
      },
      {
        subcategory: 'Роли Філадельфія',
        items: [
          {
            id: 9,
            title: 'Філадельфія з креветкою і апельсином 300г',
            price: '370 грн',
            src: require('../img/filakrevetkaiapelsin.png'),
            text: 'Креветки тигрові, крем сир, апельсин, огірок, соус спайсі.',
            zvd: 'room',
            isNew: true,
            energy: true,
          },
          // {
          //   id: 8,
          //   title: 'ФІЛАДЕЛЬФІЯ З МАСЛЯНОЮ 270г',
          //   price: '379 грн',
          //   src: require('../img/filazmaslyan.jpg'),
          //   text: 'РИС, КРЕМ-СИР, ФИЛЕ МАСЛЯНОЇ РИБИ, МАРИНОВАНА РЕДЬКА, ОГІРОК, ІКРА МАСАГО',
          //   zvd: 'orangery',
          //   isNew: true,
          //   energy: true,
          // },
          {
            id: 1,
            title: '«Філадельфія» з лососем 250г',
            price: '400 грн',
            src: require('../img/filalosoavok.jpg'),
            text: 'норі, рис, крем-сир, авокадо, ікорний продукт, лосось',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 2,
            title: '«Філадельфія» з лососем та огірком 250г',
            price: '390 грн',
            src: require('../img/filalosogur.jpg'),
            text: 'норі, рис, крем-сир, ікорний продукт, лосось, огірок',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 3,
            title: '«Філадельфія» з тигровою креветкою 300г',
            isNew: true,
            price: '390 грн',
            src: require('../img/filakrevetka.jpg'),
            text: 'норі, рис ,крем-сир, лосось, тигрова креветка, огірок, ікра масага, мигдальні пластівці',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 4,
            title: '«Філадельфія» з лососем в ікрі 270г',
            isNew: true,
            price: '379 грн',
            src: require('../img/filalosvikre.jpg'),
            text: 'норі, рис, крем-сир,ікра масага, огірок, лосось, соус манго',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 5,
            title: '«Філадельфія» з вугрем 250г',
            price: '450 грн',
            src: require('../img/filaugoravok.jpg'),
            text: 'норі, рис, крем-сир, авокадо, вугор, ікорний продукт, соус «унагі», кунжут',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 6,
            title: 'Рол Туна 270г',
            isNew: true,
            price: '360 грн',
            src: require('../img/roltuna.jpg'),
            text: 'норі, рис, огірок, ікра масага, крем-сир, тунець',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 7,
            title: `«Філадельфія» з тунцем в ікрі 270г`,
            isNew: true,
            price: '360 грн',
            src: require('../img/filatunec.jpg'),
            text: 'норі, рис, крем-сир, тунець, ікра масага, огірок, соус манго',
            zvd: 'orangery',
            energy: true,
          },
        ],
      },
      {
        subcategory: 'Роли Каліфорнія',
        items: [
          {
            id: 1,
            title: '«Каліфорнія» з лососем в ікрі 250г',
            price: '330 грн',
            src: require('../img/kallosikara.jpg'),
            text: 'норі, рис, лосось, огірок, авокадо, ікорний продукт, соус солодкий чілі',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:2,
          //     title:"«Каліфорнія» з лососем в кунжуті 250г",
          //     price:"275 грн",
          //     src:require('../img/kalloskun.jpg'),
          //     text:"норі, рис, лосось, огірок, авокадо, ікорний продукт, кунжут",
          // zvd: 'orangery',},
          {
            id: 3,
            title: '«Каліфорнія» з вугрем в ікрі 250г',
            price: '350 грн',
            src: require('../img/kalugorikra.jpg'),
            text: 'норі, рис, вугор, огірок, авокадо, ікорний продукт, соус унагі',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:4,
          //     title:"«Каліфорнія» з вугрем в кунжуті 250г",
          //     price:"295 грн",
          //     src:require('../img/kalugorkun.jpg'),
          //     text:"норі, рис, вугор, огірок, авокадо, ікорний продукт, кунжут",
          // zvd: 'orangery',},
        ],
      },
      {
        subcategory: 'Гарячі роли',
        items: [
          {
            id: 1,
            title: 'Футомакі з куркою та соусом песто в темпурі 320г',
            price: '320 грн',
            isNew: true,
            src: require('../img/futomakiKurkaSous.jpg'),
            text: 'Крука, соус песто, перець солодкий, крем сир, рис, темпура, соус спайсі',
            zvd: 'orangery',
          },
          {
            id: 2,
            title: 'ЗАПЕЧЕНИЙ З КРЕВЕТКОЮ 250г',
            price: '299 грн',
            isNew: true,
            src: require('../img/zapecheniyzkrevetkou.jpg'),
            text: 'РИС, КРЕМ-СИР, ТИГРОВА КРЕВЕТКА, ОМЛЕТ, редька, ІКРА МАСАГА, часник, шрирача, ПАРМЕЗАН, ЯПОНСЬКИЙ МАЙОНЕЗ',
            zvd: 'room',
          },
          {
            id: 3,
            title: 'ЗАПЕЧЕНИЙ З ЛОСОСЕМ 250г',
            price: '299 грн',
            isNew: true,
            src: require('../img/zapecheniyzlososem.jpg'),
            text: 'РИС, КРЕМ-СИР, ЛОСОСЬ, ОМЛЕТ, ОГІРОК, КУНЖУТ, часник, шрирача, ПАРМЕЗАН, ЯПОНСЬКИЙ МАЙОНЕЗ',
            zvd: 'room',
          },
          {
            id: 4,
            title: 'ЗАПЕЧЕНИЙ З МІДІЄЮ 250г',
            price: '299 грн',
            isNew: true,
            src: require('../img/zapecheniyzmidieu.jpg'),
            text: 'РИС, КРЕМ-СИР, МЯСО МІДІЇ, ОМЛЕТ, огірок, СТРУЖКА НОРИ, часник, шрирача, ПАРМЕЗАН, ЯПОНСЬКИЙ МАЙОНЕЗ',
            zvd: 'room',
          },
          {
            id: 5,
            title: 'Футомакі з тунцем в темпурі 400г',
            price: '400 грн',
            // isNew: true,
            src: require('../img/futlostemp.jpg'),
            text: 'рис, тунець, крем-сир, авокадо, огірок, темпура, норі, соус унагі, соус чилі солодкий',
            zvd: 'orangery',
          },
          {
            id: 6,
            title: 'Футомакі з вугрем в темпурі 300г',
            price: '400 грн',
            src: require('../img/futugortemp.jpg'),
            text: 'рис, вугор, крем-сир, огірок, темпура, норі, соус унагі, соус чилі солодкий',
            zvd: 'orangery',
          },
          {
            id: 7,
            title: 'Футомакі з лососем в темпурі 400г',
            price: '400 грн',
            src: require('../img/futlostemp.jpg'),
            text: 'рис, лосось, крем-сир, авокадо, огірок, темпура, норі, соус унагі, соус чилі солодкий',
            zvd: 'orangery',
          },

          {
            id: 8,
            title: 'Футомакі з креветкою та лососем в темпурі 380г',
            price: '400 грн',
            src: require('../img/futloskrevtemp.jpg'),
            text: 'рис, лосось, креветки, авокадо, огірок, темпура, норі, соус чилі солодкий, соус спайс ',
            zvd: 'orangery',
          },
          {
            id: 9,
            title: 'Макі з креветкою в темпурі 200г',
            price: '270 грн',
            src: require('../img/makikrevtemp.jpg'),
            text: 'рис, креветки, крем-сир, соус спайс, ікорний продукт, темпура, норі ',
            zvd: 'orangery',
          },
        ],
      },
      {
        subcategory: 'Дракони',
        items: [
          {
            id: 5,
            title: 'Рол «БІЛИЙ ДРАКОН» 270г',
            price: '399 грн',
            src: require('../img/whiteDragon.jpg'),
            text: 'Рис, креветка, крем-сир, лосось, редька дайкон, авокадо, соус манго, ікра тобіко, мікрогрін',
            zvd: 'orangery',
            isNew: true,
            energy: true,
          },
          // {
          //   id: 1,
          //   title: 'Рол «Зелений дракон» 280г',
          //   price: '339 грн',
          //   src: require('../img/zeldrak.jpg'),
          //   text: 'рис, норі, авокадо, лосось, ікорний продукт, соус «унагі», кунжут',
          //   zvd: 'orangery',
          // },
          {
            id: 2,
            title: 'Рол «Чорний дракон» 270г',
            price: '399 грн',
            src: require('../img/cherndrak.jpg'),
            text: 'норі, рис, вугор, лосось, ікорний продукт, огірок, авокадо, кунжут, соус «унагі»',
            zvd: 'orangery',
            energy: true,
          },

          {
            id: 3,
            title: 'Рол «Червоний дракон» 270г',
            price: '399 грн',
            src: require('../img/krasndrak.jpg'),
            text: 'норі, рис, авокадо, огірок, лосось, вугор, соус спайсі, ікорний продукт',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 4,
            title: 'Рол «пінк дракон» 270г',
            price: '420 грн',
            src: require('../img/pinkRoll.jpg'),
            text: 'норі, рис, авокадо, огірок, тунець, вугор, ікорний продукт, соус спайсі',
            zvd: 'orangery',
            energy: true,
          },
        ],
      },
      {
        subcategory: 'Макі',
        items: [
          {
            id: 1,
            title: 'Макі з лососем і авокадо 130г',
            price: '155 грн',
            src: require('../img/makilosavok.jpg'),
            text: 'норі, рис, авокадо, лосось',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 2,
            title: 'Макі з огірком 130г',
            price: '115 грн',
            src: require('../img/makiogur.jpg'),
            text: 'норі, рис, огірок, соус «унагі», кунжут',
            zvd: 'orangery',
            energy: true,
          },

          {
            id: 3,
            title: 'Макі з вугрем і огірком 130г',
            price: '180 грн',
            src: require('../img/makiugorogur.jpg'),
            text: 'норі, рис, огірок, вугор',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 4,
            title: 'Макі з креветкою 130г',
            price: '169 грн',
            src: require('../img/makiskrevetkoy.jpg'),
            text: 'рис, норі, креветки',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 5,
            title: 'Макі з авокадо і сиром «Філадельфія» 140г',
            price: '159 грн',
            src: require('../img/makiavok.jpg'),
            text: 'норі, рис, авокадо, крем-сир, ікорний продукт',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:6,
          //     title:"Макі з крабовим кремом 130г",
          //     price:"149 грн",
          //     src:require('../img/makikrobsir.jpg'),
          //     text:"норі, рис, крабовий крем, крем-сир",
          // zvd: 'orangery',},
        ],
      },
      {
        subcategory: 'Сети',
        items: [
          {
            id: 12,
            title: 'СЕТ ЛІТНІ ТРОПІКИ 800г',
            price: '999 грн',
            // price2:"881 грн",
            src: require('../img/litniTropik.jpg'),
            text: 'ФІЛАДЕЛЬФІЯ З тигровою креветкою та апельсином, ФІРМОВИЙ РОЛ ОРАНЖЕРЕЯ, ЗАПЕЧЕНИЙ З КРЕВЕТКОЮ',
            zvd: 'room',
            isNew: true,
          },
          {
            id: 12,
            title: 'СЕТ ЗАПЕЧЕНИХ 750г',
            price: '899 грн',
            // price2:"881 грн",
            src: require('../img/setZapechen.jpg'),
            text: 'ЗАПЕЧЕНИЙ З ЛОСОСЕМ, ЗАПЕЧЕНИЙ З КРЕВЕТКОЮ, ЗАПЕЧЕНИЙЗ МИДІЄЮ',
            zvd: 'room',
            isNew: true,
          },
          // {
          //     id:10,
          //     title:"Сет Гурман 1150г",
          //     // price2:"980 грн",
          //     price:"1100 грн",
          //     src: require('../img/gurman.jpg'),
          //     text:"Філадельфія з лососем та огірком, Рол Інь-янь, Філадельфія з тунцем в ікрі, Рол Чеддер",
          // zvd: 'orangery',},
          {
            id: 11,
            title: 'Сет «Рейнбоу» 1000г',
            price: '1250 грн',
            // price2:"881 грн",
            src: require('../img/rainbo.jpg'),
            text: 'Рол Грін, Філадельфія з лососем в ікрі, Опалений рол з лососем, Нігірі з вугрем, Нігірі з лососем, Нігірі з опаленим лососем',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //     id:12,
          //     title:"Сет Сакура 790г",
          //     price:"849 грн",
          //     // price2:"721 грн",
          //     src: require('../img/setsakura.jpg'),
          //     text:"Філадельфія з лососем та огірком, Філадельфія з лососем в ікрі, Макі з лососем і авокадо,  Нігірі з лососем 2 шт",
          // zvd: 'orangery',},

          // {
          //     id:1,
          //     title:"Сет «Катана» 1080г",
          //     price:"1130 грн",
          //     src: require('../img/setkatana.jpg'),
          //     text:"«Asama», «Гейша», «Філадельфія» з лососем, «Каліфорнія» з вугрем в ікрі",
          // zvd: 'orangery',},
          // {
          //     id:2,
          //     title:"Сет «Тропіки» 1246г",
          //     price:"1200 грн",
          //     src:require('../img/settropik.jpg'),
          //     text:"«Asama», «Yoko», фірмовий рол «Оранжерея», «Гейша», нігірі з обпаленим лососем",
          // zvd: 'orangery',},

          // {
          //     id:3,
          //     title:"Сет «Самурай» 1000г",
          //     price:"1100 грн",
          //     src:require('../img/setsamuray.jpg'),
          //     text:"фірмовий рол «Оранжерея», «Yoko», «Філадельфія» з лососем, «Фламінго»",
          // zvd: 'orangery',},
          {
            id: 4,
            title: 'Сет «4 дракони» 1000г',
            price: '1600 грн',
            src: require('../img/setfourdrag.jpg'),
            text: 'БІЛИЙ ДРАКОН, ЧЕРВОНИЙ ДРАКОН, ПИНК ДРАКОН, ЧОРНИЙ ДРАКОН',
            zvd: 'room',
            energy: true,
          },
          // {
          //     id:5,
          //     title:"Сет «На двох» 810г",
          //     price:"770 грн",
          //     src:require('../img/setnadvoih.jpg'),
          //     text:"«Філадельфія» з лососем, футомакі з вугрем та лососем, макі з авокадо і сиром «Філадельфія», нігірі з лососем 2шт",
          // zvd: 'orangery',},
          // {
          //     id:6,
          //     title:"Сет «На компанію» 1350г",
          //     price:"1300 грн",
          //     src:require('../img/setnakomp.jpg'),
          //     text:"футомакі з лососем в темпурі, «Кімамі» гострий, рол з обпаленим лососем, «Філадельфія» з вугрем і авокадо, макі з креветкою в темпурі",
          // zvd: 'orangery',},

          // {
          //     id:7,
          //     title:"Сет «Фірмовий» 1050г",
          //     price:"1200 грн",
          //     src: require('../img/setfirm.jpg'),
          //     text:"фірмовий рол «Оранжерея», «Гейша», «Філадельфія» з лососем, «Каліфорнія» з лососем в ікрі",
          // zvd: 'orangery',},
          // {
          //     id:8,
          //     title:"Сет «Каліфорнія» 1000г",
          //     price:"1000 грн",
          //     src:require('../img/setkal.jpg'),
          //     text:"«Каліфорнія» з вугрем в ікрі, «Каліфорнія» з лососем в кунжуті, «Каліфорнія» з вугрем в кунжуті, «Каліфорнія» з лососем в ікрі",
          // zvd: 'orangery',},

          {
            id: 9,
            title: 'Сет «Love Фан-Філ» 1030г',
            price: '1450 грн',
            src: require('../img/fanfil.jpg'),
            text: '«ФІЛАДЕЛЬФІЯ» З ЛОСОСЕМ і огірком, Рол Туна, МАКІ З АВОКАДО І СИРОМ «ФІЛАДЕЛЬФІЯ» 2ШТ, «ФІЛАДЕЛЬФІЯ» З ВУГРЕМ',
            zvd: 'orangery',
            energy: true,
          },
        ],
      },
      {
        subcategory: 'суші-бургери',
        items: [
          // {
          //     id:1,
          //     title:"Бургер з крабом і манго 300г",
          //     //  price2:"345 грн",
          //     price:"360 грн",
          //     src: require('../img/burgkrabmango.jpg'),
          //     text:"норі, рис, сухарі панко, кляр темпура, крем-сир, краб-крем, манго, сир чеддер, соус унаги і солодкий чілі",
          // zvd: 'orangery',},
{
              id:1,
              title:"Бургер з креветкою 300г",
              //  price2:"345 грн",
              price:"380 грн",
              src: require('../img/burgerzkrevetkoyou.jpg'),
              text:"Рис, норі, крем сир, сир Чеддер, манго, паніровка, соус унагі, соус солодкий чилі.",
          zvd: 'room',},
          {
            id: 2,
            title: 'Бургер з тунцем 300г',
            // price2:"345 грн",
            price: '380 грн',
            src: require('../img/burgtunec.jpg'),
            text: 'норі, рис, сухарі панко, кляр темпура, огірок, крем-сир, тунець, сир чеддер, соус солодкий чілі',
            zvd: 'room',
          },
          {
            id: 3,
            title: 'Бургер з лососем 300г',
            // price2:"360 грн",
            price: '380 грн',
            src: require('../img/burglosos.jpg'),
            text: 'норі, рис, сухарі панко, кляр темпура, крем-сир, лосось, авокадо, сир чеддер, соус унагі',
            zvd: 'room',
          },
        ],
      },
    ],
  },
  {
    category: 'Європейська кухня',
    subcategories: [
      {
        subcategory: 'Холодні закуски',
        items: [
          {
            id: 1,
            title: 'Спрінг роли 280г',
            price: '370 грн',
            src: require('../img/springRoll.webp'),
            text: 'Рисовий папір, авокадо, огірок, крем-сир, лист салату, лосось, креветка тигрова, перець болгарський, морква, соус горіховий, соус «Солодкий Чилі»',
            description: `Свіжа закуска, що включає три види ролів: з лососем, тигровими креветками та овочами з крем-сиром. Всі роли загорнуті в рисовий папір і доповнені горіховим соусом, що надає страві глибини та багатства смаку. `,
            zvd: 'room',
            energy: true,
          },
          {
            id: 2,
            title: 'Карпачо з тунця 130г',
            price: '299 грн',
            src: require('../img/karpachoTun.webp'),
            text: 'Тунець, Каперси, Руккола, Заправка, Крем бальзамік',
            description: `Тонко нарізаний тунець, доповнений каперсами та свіжим міксом салату. Легка заправка та крем бальзамік надають страві пікантності та гармонійно підкреслюють смак риби, створюючи легку і смачну закуску.`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 3,
            title: 'Вітелло тоннато 140г',
            price: '285 грн',
            src: require('../img/vitelloTonnato.webp'),
            text: 'Ростбіф, соус «Вітелло Тонатто» каперси, масло оливкове',
            description: `Ніжний ростбіф з соусом тоннато на основі оливкової олії і каперсів, що надають страві пікантності та глибини смаку. Цей класичний італійський делікатес створює ідеальний баланс між м'ясом і соусом.`,
            zvd: 'room',
          },
          {
            id: 5,
            title: 'Сирне Плато 240г',
            price: '375 грн',
            src: require('../img/tarilkaGurmana.webp'),
            text: `Пармезан, дор-блю, камамбер, гауда, мед, кедрові горіхи, мигдалеві пластівці, полуниця`,
            description: ``,
            zvd: 'room',
            energy: true,
          },
          {
            id: 6,
            title: 'Мʼясна класика 220г',
            price: '385 грн',
            src: require('../img/myasnsTarilka.webp'),
            text: 'Пепероні, балик, ростбіф, прошутто, ніжний хрін, маслини',
            description: `Асорті з баликом, ростбіфом, пепероні та прошуто, доповнене маслинами та соусом з хріну та вершків. Це смачне поєднання м'ясних делікатесів з пікантним соусом, що підкреслює їх смак.`,
            zvd: 'room',
            energy: true,
          },
          // {
          //   id: 7,
          //   title: 'Фруктове асорті',
          //   price: '250 грн',
          //   src: require('../img/fruktAssorti.webp'),
          //   text: ``,
          //   description: ``,
          //   zvd: 'room',
          // },
          {
            id: 8,
            title: 'Палітра сала 260г',
            price: '280 грн',
            src: require('../img/palitraSala.webp'),
            text: 'Панчетта, сало з кропом, сало з паприкою, хліб темний, хрін',
            description: `Хліб бородинський з панчеттою та двома видами сала — білим салом з укропом і салом в паприці. Смачне поєднання соленого та копченого смаків, що гармонійно доповнюються пікантним хріном.`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 9,
            title: 'Оселедець з картоплею 350г',
            price: '255 грн',
            src: require('../img/oseledec.jpg'),
            text: 'Оселедець, оливкова олія, цибуля, картопля, часник, зелень',
            description: `Пряний оселедець подається зі смаженою картоплею, маринованою ріпчастою цибулею та свіжою зеленню. Ситна й смачна закуска, натхненна домашньою кухнею`,
            zvd: 'room',
          },
        ],
      },
      {
        subcategory: 'Брускети',
        items: [
          {
            id: 1,
            title: 'З прошутто 70г',
            price: '125 грн/шт',
            src: require('../img/bruskProsutto.jpg'),
            zvd: 'room',
            text: 'Чіабатта, крем-сир, прошутто, вʼялені томати, руккола, сир дор-блю, крем бальзамік',
            description: `Хрустка чіабатта з крем-сиром, в'яленими томатами та прошуто, доповнена свіжою руколою і сиром дорблю. Крем бальзамік додає глибини смаку, створюючи збалансовану і вишукану закуску.`,
            energy: true,
          },
          {
            id: 2,
            title: 'З лососем 60г',
            price: '130 грн/шт',
            src: require('../img/bruskLosos.jpg'),
            zvd: 'room',
            text: 'Чіабатта, крем-сир, авокадо, лосось',
            description: `Хрустка чіабатта, з крем-сиром, доповнена скибочками авокадо та лосося, що створює вишукану закуску з гармонійним поєднанням смаків.`,
            energy: true,
          },
          {
            id: 3,
            title: 'З томатами та моцарелою 60г',
            price: '110 грн/шт',
            zvd: 'room',
            src: require('../img/bruskTomat.jpg'),
            text: 'Чіабатта, томат черрі, моцарела, базилік, часник, олія оливкова',
            description: `Хрустка чіабатта з соковитими черрі, моцарелою та ароматним базиліком, доповнена часником і оливковою олією. Легкі спеції підкреслюють свіжість інгредієнтів, створюючи ідеальну закуску з яскравим смаком.`,

            energy: true,
          },
          {
            id: 4,
            title: 'З тигровими креветками 70г',
            price: '125 грн/шт',
            zvd: 'room',
            src: require('../img/bruskKrevetka.jpg'),
            text: 'Чіабатта, крем-сир, креветка тигрова, авокадо, лист салату, томат черрі, соус «Солодкий Чилі»',
            description: `Хрустка чіабатта з крем-сиром, авокадо та тигровими креветками, доповнена свіжим листом салату та черрі. Легкий соус світ-чілі додає пікантності, створюючи гармонійний смак цієї смачної закуски.`,

            energy: true,
          },
          {
            id: 5,
            title: 'з анчоусом 80г',
            price: '130 грн/шт',
            zvd: 'room',
            src: require('../img/brusketAnch.jpg'),
            text: 'Анчоуси, хліб бородинський, сир вершковий, цибуля шалот, помідори чері',
            description: `Рум’яний бородинський хліб із ніжним крем-сиром, доповнений пряним анчоусом, солодкуватою цибулею шалот і соковитими томатами чері. Вишукана гра текстур і смаків в одній брускеті!`,

            energy: true,
          },
          {
            id: 6,
            title: 'з ростбіфом 80г',
            price: '145 грн/шт',
            zvd: 'room',
            src: require('../img/brusketRost.jpg'),
            text: `Ростбіф, хліб бородинський, сир вершковий, цибуля шалот, каперси, томати в'ялені, бальзамік`,
            description: `Рум’яний бородинський хліб із ніжним крем-сиром, соковитим ростбіфом і пікантною цибулею шалот. В’ялені томати додають глибину смаку, а каперси й бальзамічний соус завершують цю ідеальну гастрономічну композицію`,

            energy: true,
          },
        ],
      },
      {
        subcategory: 'Перші страви',
        items: [
          {
            id: 1,
            title: 'Французький цибулевий суп 320г',
            price: '180 грн',
            src: require('../img/suocibulya.jpg'),
            text: `Цибуля ріпчаста, олія оливкова, масло вершкове, вино біле, сир пармезан, сир Моцарелла, чіабатта`,
            description: `Ніжно карамелізована цибуля у вершково-винному соусі, запечена під пармезаном і моцарелою з чіабаттою — класика французької кухні`,
            zvd: 'room',
          },
          {
            id: 2,
            title: 'Гарбузовий крем-суп з креветками 380г',
            price: '230 грн',
            src: require('../img/garbuzoviyKremSupZKrevetkami.webp'),
            text: `Гарбузове пюре, вершки, креветка тигрова, гарбузове насіння, пластівці мигдалю`,
            description: `Ніжний суп на основі гарбузового пюре, з вершковою текстурою, доповнений соковитими тигровими креветками. Ароматні спеції та гарбузове насіння додають страві особливого шарму, а пластівці мигдалю підкреслюють її вишуканість і легку хрусткість.`,
            zvd: 'room',
          },
          // {
          //   id: 3,
          //   title: 'Фо Бо 360г',
          //   price: '190 грн',
          //   src: require('../img/fobo.webp'),
          //   text: `Бульйон, паста чорна, ростбіф, лайм`,
          //   description: `Це вишуканий ароматний суп, що поєднує в собі тонкі чорні локшини, соковитий ростбіф та багатий наваристий бульйон. Спеції надають страві глибину смаку, а свіжий лайм та м'ята вносять нотки свіжості і пікантності.`,
          // zvd:'room',},
          {
            id: 3,
            title: 'Том Ям 400г',
            price: '370 грн',
            src: require('../img/tomyam.webp'),
            text: `Бульйон, паста «том-ям», креветка тигрова, лосось, мідії, печериці, томати черрі, вершки, лайм, базилік, рис, перець чилі`,
            description: `Гострий і ароматний суп з тигровими креветками, лососем і мідіями, що поєднує в собі багатство морських смаків. Наваристий бульйон із спеціями дає пікантність і глибину, а вершки надають ніжної текстури. Черрі, печериці та базилік додають свіжість, а лимонний сік і скибочки лимона — яскраву цитрусову нотку. Це блюдо створене для поціновувачів гострих та насичених смаків, які люблять відчувати багатство кожного інгредієнта.`,
            zvd: 'room',
          },
          // {
          //   id: 4,
          //   title: 'Пучеро 350г',
          //   price: '210 грн',
          //   src: require('../img/puchero.webp'),
          //   text: `Філе куряче, ростбіф, прошутто, бекон, картопля, цибуля ріпчаста, бульйон, соус «Шрірача», лимон, каперси, маслини`,
          //   description: `Ситний, наваристий суп, що поєднує в собі різноманітні види м'яса, включаючи куряче філе, ростбіф, прошутто та бекон, створюючи багатий смаковий профіль. Картопля та ароматний бульйон додають глибини страві, а каперси та маслини надають їй пікантності. `,
          // zvd:'room',},
          {
            id: 5,
            title: 'Грибний крем-суп 220г',
            price: '180 грн',
            src: require('../img/gribniyKremSup.webp'),
            text: `Печериці, гриби білі, цибуля ріпчаста, вершки`,
            description: `Вишуканий суп, що поєднує в собі ніжні печериці та аромати білих грибів, збагачений цибулею та вершками для досягнення м'якої кремової текстури і глибокого смаку. Ідеальний для холодних вечорів.`,
            zvd: 'room',
          },
          // {
          //   id: 6,
          //   title: 'Окрошка з індичкою 250г',
          //   price: '250 грн',
          //   zvd: 'room',
          //   src: require('../img/okroshka.jpg'),
          //   text: `Сметана, хрін, зелень, помідор черрі, картопля, огірок, яйце куряче, редис, лимон`,
          //   description: `Легка холодна страва зі свіжих овочів, відвареного філе індички та яйця. Подається з бородинським хлібом. Заправка на основі сметани, хріну та зелені подається окремо для зручності.`,
          // },
        ],
      },
      {
        subcategory: 'Салати',
        items: [
          {
            id: 10,
            title: 'Салат з креветками Флоу 240г',
            price: '310 грн',
            src: require('../img/saladFlou.png'),
            text: 'Креветка тигрова, манго, помідори черрі, микс свіжого салату, соус солодкий чилі, салатна заправка, мигдальні хлопья, лайм',
            description: `Обсмажені тигрові креветки з соковитим манго, помідорами чері та міксом свіжої зелені під ніжною заправкою з солодкого чилі. Декоровано мигдальними пелюстками та скибочкою лайма. Подача — оригінальна: салат ефектно сервірують із келиха при гостях, створюючи легкий вау-ефект.`,
            zvd: 'orangery',
            // energy: true
          },
          {
            id: 1,
            title: 'Панцанелла 190г',
            price: '180 грн',
            src: require('../img/pancanella.webp'),
            text: 'черрі, огірок, шалот, заправка, чіабата, базилік, маслини, спеції, олія оливкова, кедровий горіх',
            description:
              'Салат Панцанелла — класичний італійський салат, який поєднує свіжі овочі з хрусткими шматочками чіабатти, обсмаженими до золотистої скоринки. Черрі, огірок і шалот створюють легкість, а маслини і базилік додають аромату. Заправка на основі оливкової олії підкреслює смак, а кедрові горіхи придають страві ніжний хруст. Всі інгредієнти гармонійно поєднуються для створення смачного і ситного блюда.',
            zvd: 'room',
            energy: true,
          },
          {
            id: 2,
            title: 'Цезар з куркою 260г',
            price: '300 грн',
            src: require('../img/cezarKurka.webp'),
            text: 'Мікс салату, куряче філе, каперси, соус цезар, пармезан, чіабатта, томат черрі , бекон',
            description: `Соковите куряче філе, хрустка чіабатта та бекон, доповнені класичним соусом Цезарь. Каперси та пармезан надають страві насиченості, а черрі привносять свіжість і легкість, створюючи ідеальний баланс смаку.`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 3,
            title: 'салат з ростбіфом 180г',
            price: '280 грн',
            src: require('../img/saladRostb.webp'),
            text: 'Ростбіф, Мікс салату, Соус айолі, В`ялені томати, Цибуля шалот, Каперси, Соус вишневий',
            description: `Соковиті шматочки ростбіфу поєднуються з ніжним міксом салату та ароматними в’яленими томатами. Легкий соус айолі додає кремової текстури, а шалот і каперси привносять гостроту та пікантність. Вишневий соус додає легку фруктову нотку, що гармонійно доповнює страву. Це ідеальний вибір для любителів м’ясних салатів з яскравим смаковим акцентом.`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 4,
            title: 'Нісуаз 210г',
            price: '320 грн',
            src: require('../img/nisuaz.webp'),
            text: 'Тунець, кунжут, мікс салату, томат черрі, картопля, яйце пашот, цибуля шалот, заправка',
            description: `Класичний французький салат, що поєднує соковитий тунець, жарений у кунжуті, з картоплею, яйцем та свіжими овочами. Мікс салату, черрі та шалот додають легкості і свіжості, а заправка на основі оливкової олії та італійських трав підкреслює гармонійність усіх інгредієнтів. Цей салат — ідеальний вибір для любителів вишуканих смаків.`,
            zvd: 'room',
          },
          {
            id: 5,
            title: 'салат з лососем 250г',
            price: '370 грн',
            src: require('../img/saladLosos.webp'),
            text: 'мікс салату, соус айолі, лосось, авокадо, томат черрі, кедрові горіхи, заправка',
            description: `Ніжне філе лосося поєднується з міксом салату та авокадо, створюючи ідеальний баланс смаку та текстур. Легкий соус айолі додає кремової нотки, а черрі та кедрові горіхи підкреслюють свіжість і хрусткість. Цей салат стане справжнім делікатесом для поціновувачів морепродуктів.`,
            zvd: 'room',
          },
          {
            id: 6,
            title: 'салат з прошутто та горгондзолою 180г',
            price: '299 грн',
            src: require('../img/saladProshuttoGorgonzola.webp'),
            text: 'мікс салату, прошутто, сир дор-блю, в’ялені томати, груша, базилік, крем бальзамік, цибуля шалот',
            description: `Вишукане поєднання ніжного прошутто, сиру дорблю та ароматних в’ялених томатів, які доповнюються свіжістю міксу салату та груші. Французька гірчиця та лимонний сік надають пікантну нотку, а крем бальзамік завершує гармонійний смак страви. Це ідеальний салат для любителів вишуканих поєднань смаків.`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 7,
            title: 'салат з курячою печінкою 230г',
            price: '290 грн',
            src: require('../img/saladKurPech.webp'),
            text: 'Мікс салату, печінка куряча, соус «Солодкий Чилі» , сир камамбер, груша, кедрові горіхи, кунжут',
            description: `Ніжна куряча печінка смажиться до золотистої скоринки і поєднується з міксом салату та сиром камамбер, додаючи кремову текстуру. Груша привносить легку солодкість, а соус світ-чілі надає пікантності. Кедрові горіхи та кунжут додають хрусткості і аромату, роблячи салат смачним і гармонійним.`,
            zvd: 'room',
          },
          {
            id: 8,
            title: 'Салат з восьменіжками та французьким песто 280г',
            price: '350 грн',
            src: require('../img/saladZVosem.jpg'),
            text: 'Восьменіжки, картопля, цибуля шалот, помідори чері, мікс салату, соус песто, гірчиця, часник, соєвий соус, фісташки, лимон',
            description: `Ніжні восьменіжки в поєднанні з обсмаженою картоплею, свіжими томатами чері та цибулею шалот. Листя міксу салату додають легкості, а песто, французька гірчиця та соєвий соус створюють багатогранний смак. Фісташки надають хрусткої текстури, а лимонний сік і бальзамічний крем підкреслюють свіжість і пікантність страви`,
            zvd: 'room',
          },
        ],
      },
      {
        subcategory: 'Гарячі закуски',
        items: [
          {
            id: 15,
            title: 'Снек-борд для компанії 1000г/150г',
            price: '900 грн',
            src: require('../img/sneckBord.jpg'),
            text: `Крильця баффало, цибулеві кільця, сухарики мюнхенські, сир фрі, картопля фрі, соус айолі, соус томатний, соус солодкий чилі`,
            description: `Асорті гарячих закусок: крильця баффало, цибулеві кільця, мюнхенські сухарики, сир фрі та картопля фрі. Подається з соусами айолі, томатним і солодким чилі — ідеально для великої компанії`,
            zvd: 'room',
          },
          {
            id: 14,
            title: 'Свинина в кисло-солодкому соусі 190г',
            price: '270 грн',
            src: require('../img/svininakislosladkaya.jpg'),
            text: `Свинина, крохмаль, соус соєвий, олія, кетчуп, міцукан, мед, часник, імбир, кунжут`,
            description: `Соковита свинина у класичному кисло-солодкому соусі з нотами соєвого соусу, меду, імбиру та часнику, доповнена кунжутом`,
            zvd: 'room',
          },
          {
            id: 13,
            title: 'Курка теріякі 200г',
            price: '260 грн',
            src: require('../img/kurkatiriyaki.png'),
            text: `Філе курки, соус теріякі, часник, кунжут, нитки чілі`,
            description: ``,
            zvd: 'room',
          },
          {
            id: 1,
            title: 'Мідії під сирною шапкою 130г',
            price: '260 грн',
            src: require('../img/midiiPidSirShapk.webp'),
            text: `Мідії, Сирний крем на мідії, Унагі, Лайм, Кунжут`,
            description: `Соковиті мідії, запечені під кремовим сиром, доповнені соусом унагі, що додає солодкувато-солоного акценту. Лайм і кунжут підкреслюють смак страви, надаючи їй легкості та свіжості.`,
            zvd: 'room',
          },
          // {
          //   id: 2,
          //   title: 'Баклажани Пармеджано 210г',
          //   price: '210 грн',
          //   src: require('../img/baklajanParmedgano.webp'),
          //   text: `Баклажан, моцарела, пармезан, вʼялені томати соус томатний, соус «Шрірача»`,
          //   description: `Смажені баклажани, запечені з моцарелою та пармезаном, покриті томатним соусом з в'яленими томатами. Пікантний соус шрірача додає гостроти, створюючи смачну та ароматну страву, що поєднує класичні смаки з оригінальним акцентом.`,
          // zvd:'room',},
          // {
          //   id: 3,
          //   title: 'Фрітатта з лососем 250г',
          //   price: '240 грн',
          //   src: require('../img/fritatazLososem.webp'),
          //   text: `Яйця курячі, вершки, лосось, пармезан, томат черрі, печериці, цибуля ріпчаста, олія оливкова`,
          //   description: `Класична італійська страва, що поєднує ніжний омлет з лососем, печерицями та черрі, приправлений ароматним пармезаном.`,
          // zvd:'room',},
          //           {
          //             id: 4,
          //             title: 'Шашлички якіторі 220г',
          //             price: '370 грн',
          //             src: require('../img/shashlYakitori.webp'),
          //             text: `Лосось, тунець, креветка тигрова, печериці , томати черрі, мікс салату, заправка, Соус унагі, лайм, кунжут`,
          //             description: `Три шашлички, на кожному з яких шматочок лосося, тунця та креветки, приготовані до золотистої скоринки і покриті соусом унагі. Подаються на подушці з міксу салату, що створює ідеальну гармонію свіжості та насичених смаків.

          // `,
          //             zvd: 'room',
          //           },
          {
            id: 5,
            title: 'Крильця Баффало 440г/100г',
            price: '330 грн',
            src: require('../img/krilyaBafalo.webp'),
            text: `Курячі крила, соус «Сололкий Чилі» ,соус «Шрірача», сир дор-блю, вершки`,
            description: `Хрусткі курячі крильця, обвалені в соусі світ-чілі, що додають їм солодкої гостроти. Подаються з кремовим соусом на основі вершків та сиру гарганзола, що забезпечує м'який і насичений смак, ідеально контрастуючи з пікантною основою.`,
            zvd: 'room',
          },
          // {
          //   id: 6,
          //   title: 'Омлет з тигровими креветками 220г',
          //   price: '240 грн',
          //   src: require('../img/omletZTigrKrevetkami.webp'),
          //   text: `Яйця курячі, вершки, креветка тигрова, крем-сир, шпинат, томат черрі, соус «Песто»`,
          //   description: `Ніжний омлет з ароматною начинкою з креветок, шпинату та крем-сиру, що дарує неперевершений смак. Подається з яскравою сальсою, яка додає свіжості і контрастує з багатством смаку омлету.`,
          // zvd:'room',},
          {
            id: 7,
            title: 'Попкорн з креветок 140г',
            price: '270 грн',
            src: require('../img/popcornzKrevetok.webp'),
            text: `Креветка тигрова темпура, рисовий папір, соус «Солодкий Чилі», соєвий соус, сік апельсину, кунжут`,
            description: `Тигрові креветки в хрусткому клярі на рисовому чіпсі, политі солодко-гострим соусом з нотками апельсину. Їхній ніжний м'ясний смак доповнюється пікантною хрусткістю, а апельсинові нотки додають свіжості й легкості кожному шматочку.`,
            zvd: 'room',
          },
          {
            id: 8,
            title: 'Картопля Гурме з беконом 240г',
            price: '230 грн',
            src: require('../img/kartoplyaPechenaZBekonom.webp'),
            text: `Картопля, бекон, цибуля ріпчаста, пармезан, вершки, часник, томат черрі, мікс салату`,
            description: `Ніжна запечена картопля, збагачена ароматним беконом, пармезаном та часником, з кремовим відтінком вершків. Подавана на подушці з міксу салату та черрі, дарує справжнє задоволення від поєднання смачних інгредієнтів.`,
            zvd: 'room',
          },
          // {
          //   id: 9,
          //   title: 'Сирні крокети 100г',
          //   price: '180 грн',
          //   src: require('../img/sirniKroketi.webp'),
          //   text: `Моцарела, дор-блю, панірувальні сухарі, соус вишневий, крем-сир`,
          //   description: `Сирні крокети з моцарелою та дорблю, обсмажені до ідеальної хрусткості, з ніжною, тягучою начинкою всередині. Подаються з вишневим соусом і соусом світ-чілі, які додають неповторного смакового контрасту. `,
          //   zvd: 'room',
          // },
          {
            id: 9,
            title: 'Сирні палички 150г',
            price: '229 грн',
            src: require('../img/sirpalki.jpg'),
            text: 'соус вишневий',
            zvd: 'orangery',
          },
          {
            id: 10,
            title: 'Картопля фрі 150г/50г',
            price: '120 грн',
            src: require('../img/kartoplyaFree.webp'),
            text: `Картопля фрі,
Соус томатний,
Сіль,
Спеції 
`,
            description: `Хрустка картопля фрі, ідеально обсмажена до золотистої скоринки, подається з класичним томатним соусом. Простота і смак, що завжди радують.`,
            zvd: 'room',
          },
          {
            id: 11,
            title: 'Картопля по-паприканськи 200г/50г',
            price: '130 грн',
            src: require('../img/kartoplyaPechena.webp'),
            text: `Картопля, сіль, спеції, часник, соус айолі`,
            description: `Смажена до хрусткої скоринки, з ароматними специями та часником. Подається з соусом айолі, що додає страві ніжності і багатства смаку.`,
            zvd: 'room',
          },

          {
            id: 12,
            title: 'Соте з гребінців 150г',
            price: '320 грн',
            src: require('../img/grebenci.jpg'),
            text: `Морські гребенці, вершки, сир пармезан, часник, манго, прошутто`,
            description: `Делікатна та вишукана страва, де ніжні морські гребенці поєднуються з кремовими вершками та ароматним прошутто. Солодке манго додає екзотичної нотки, а пармезан дарує страві глибину смаку. Ідеальний баланс текстур і смаків, що створює справжнє задоволення для гурманів`,
            zvd: 'room',
          },
        ],
      },
      {
        subcategory: 'Основні страви',
        items: [
          {
            id: 1,
            title: 'Лазанья з телятиною 320г ',
            price: '350 грн',
            src: require('../img/lazaniya.jpg'),
            text: `Телятина, паста лазанья, цибуля ріпчаста, помідор, вершки, соус песто, олія, часник, сир Моцарелла, сир пармезан`,
            description: `Соковита телятина з томатом та цибулею, шар за шаром із пастою лазанья, вершковим соусом і песто, запечена під моцарелою та пармезаном — для поціновувачів ніжного смаку`,
            zvd: 'room',
            isNew: true,
          },
          {
            id: 2,
            title: 'Деруни з білими грибами 350г ',
            price: '270 грн',
            src: require('../img/deruniBiliGribi.jpg'),
            text: `Картопля, гриби білі, печериці, вʼялені томати, цибуля, яйце куряче, вершки`,
            description: `Хрусткі картопляні деруни, подані з вершковим соусом із білих грибів і печериць, шалоту та часнику, доповненим в’яленими томатами. Вишукана інтерпретація домашньої класики`,
            zvd: 'orangery',
            isNew: true,
          },
          // {
          //   id: 1,
          //   title: 'Медальйони з телятини в беконі 300г',
          //   price: '340 грн',
          //   src: require('../img/medalyonizTelyatiniVBekoni.webp'),
          //   text: `Теляча вирізка, бекон, картопля, соус айолі, соус вишневий, томат черрі`,
          //   description: `Це вишукане та соковите блюдо, де ніжна теляча вирізка загорнута в хрусткий бекон, що додає їй неповторного смаку і аромату. Картопля, приготована до ідеальної м'якості, гармонійно доповнює страву, а соуси айолі та вишневий надають їй кремової текстури та легку кислинку. Черрі додають свіжості, а тем'ян підкреслює пряний аромат. Ця страва чудово підходить для любителів м'ясних делікатесів і створює неповторне поєднання смаків.`,
          // zvd:'room',
          // },
          // {
          //   id: 2,
          //   title: 'Стейк з лосося 250г',
          //   price: '410 грн',
          //   src: require('../img/stakeLosos.webp'),
          //   text: `Лосось, гарбузове пюре, апельсин, соус айолі`,
          //   description: `Стейк із лосося, ніжний та соковитий, ідеально поєднується з цитрусовими нотками апельсину, що надають страві свіжості. Подається на м’якому гарбузовому пюре, яке гармонійно доповнює рибу своєю солодкуватою текстурою. Легка пікантність соусу айолі додає глибину смаку, а ароматні спеції і тем'ян розкривають смакову палітру страви.`,
          // zvd:'room',
          // },
          {
            id: 3,
            title: 'Телятина з білими грибами 320г',
            price: '420 грн',
            src: require('../img/telyanimaSGribami.webp'),
            text: `Теляча вирізка, печериці, гриби білі, цибуля ріпчаста, вершки, моцарела, пармезан, часник`,
            description: `Це вишукана страва, де ніжна теляча вирізка гармонійно поєднується з ароматними білими грибами та шампіньйонами. Гриби додають страві глибокого смаку та текстури, а цибуля та тем'ян підкреслюють природні аромати м'яса. Кремові вершки надають ніжності, а топінг із моцарели та пармезану утворює смачну, золотисту скоринку. Це справжня кулінарна насолода для гурманів, що поєднує в собі смачну м'якість та багатий аромат лісових грибів.`,
            zvd: 'room',
          },
          {
            id: 4,
            title: 'Гратен з креветками 220г',
            price: '299 грн',
            src: require('../img/gratenzkrevetkami.webp'),
            text: `Картопля, креветка тигрова, пармезан, моцарела, вершки, часник, базилік`,
            description: `Ситне і смачна страва, що поєднує ніжність картоплі, соковитість тигрових креветок і ароматний сирний соус. Тонкі скибочки картоплі запечені до золотистої скоринки разом з креветками, створюючи гармонійну текстуру та смакову глибину. Вершки та сири пармезан і моцарела надають страві кремової ніжності, а спеції, часник і базилік додають неповторну пікантність. Це ідеальне поєднання для любителів класичних запечених страв з морепродуктами.`,
            zvd: 'room',
          },
          {
            id: 5,
            title: 'Чорна паста з куркою у винному соусі 280г',
            price: '250 грн',
            src: require('../img/chornapastakurka.jpg'),
            text: `Паста чорна, філе куряче сувід, вино біле, олія оливкова, масло вершкове, часник, крем бальзамік, соус соєвий, перець солодкий, морква, пармезан`,
            description: `Чорна паста з курячим філе сувід у ніжному вершково-винному соусі з обсмаженими овочами та пармезаном — страва для поціновувачів вишуканого, збалансованого смаку`,
            zvd: 'room',
          },
          {
            id: 6,
            title: 'чорна Паста з креветками 280г',
            price: '310 грн',
            src: require('../img/pastazKrevetkami.webp'),
            text: `Паста чорна, креветка тигрова, томат черрі, вершки, пармезан, часник, базилік`,
            description: `Чорний колір пасти надає страві елегантного вигляду, а поєднання креветок, смаженого часнику та вершків створює багатий і кремовий смак. Черрі додає легкості та свіжості, а пармезан підкреслює глибину смаку. Страва завершена ароматним базиліком, що надає нотки свіжості та аромату.`,
            zvd: 'room',
          },
          {
            id: 7,
            title: 'чорна Паста карбонара 250г',
            price: '250 грн',
            src: require('../img/pastaKarbonara.webp'),
            text: `Паста чорна, бекон, яйце куряче, пармезан, базилік`,
            description: `Класична італійська страва з пастою, беконом і ніжним соусом з яєць та пармезану. Паста покрита кремовим соусом, що поєднує сири та яєчний жовток, а бекон додає ароматного смаку та хрусткої текстури. Завершено страву базиліком, що надає легку свіжість і відтінок аромату.`,
            zvd: 'room',
          },
          {
            id: 8,
            title: 'чорна Паста з грушою та горгондзолою 280г',
            price: '255 грн',
            src: require('../img/pastaGrushaGargonzola.webp'),
            text: `Паста чорна, груша, дор-блю, вершки, пармезан, кедрові горіхи`,
            description: `Витончене поєднання солодкої груші та пікантної горгонзоли, яке створює гармонійний баланс між солодким та солоним смаком. Вершковий соус на основі вершків та сиру горгонзола надає страві кремову текстуру, а пармезан підкреслює глибину смаку. Легкий відтінок лимона і м'яти додає свіжості, а кедрові горіхи — хрустку нотку. `,
            zvd: 'room',
          },
          {
            id: 9,
            title: 'Куряче філе з соусом песто 320г',
            price: '360 грн',
            src: require('../img/kurFilePesto.webp'),
            text: `Філе куряче, томат черрі, соус песто, моцарела, пармезан, дор-блю, вершки`,
            description: `Обсмажене куряче філе, покрите ароматним соусом песто, який чудово гармоніює з соковитими помідорами чері та запеченими сирами моцарела і пармезан. Вишукана комбінація вершків з гарганзолою додає страві кремову ніжність і легку пікантність, створюючи яскраву гру смаків, що залишає незабутнє враження.`,
            zvd: 'room',
          },
          {
            id: 10,
            title: 'Стейк із свинини з картоплею  240г/50г',
            price: '380 грн',
            src: require('../img/steykPays.png'),
            text: `Свинина, картопля, помідор чері, соус BBQ, перець чилі`,
            description: `Стейк із соковитого свинячого ошийка, обсмажений до золотистої скоринки, подається з хрусткою картоплею, ароматним соусом BBQ та запеченими томатами чері, які додають страві ніжної кислинки. Ідеальне поєднання смаків для справжніх гурманів`,
            zvd: 'room',
          },
        ],
      },
      // {
      //   subcategory: 'Піца',
      //   items: [
      //     {
      //       id: 1,
      //       title: 'Піца сирна 500г',
      //       price: '360 грн',
      //       src: require('../img/sirnaya.jpg'),
      //       text: 'Вершки, сир дорблю, сир чедер, сир камамбер, сир моцарелла, сир твердий, сир пармезан, вершковий сир, соус вишневий',
      //       zvd: 'orangery',
      //     },
      //     {
      //       id: 2,
      //       title: "Піца м'ясна 650г",
      //       price: '330 грн',
      //       src: require('../img/myaso.jpg'),
      //       text: "Ковбаса чорізо, бекон, білі гриби, балик, філе курки, соус для піци, моцарелла, томати в'ялені",
      //       zvd: 'orangery',
      //     },
      //     {
      //       id: 3,
      //       title: 'Піца гавайська 650г',
      //       price: '330 грн',
      //       src: require('../img/gavai.jpg'),
      //       text: 'Філе курки, балик, ананас, манго, соус для піци, соус солодкий чилі, моцарелла, пармезан',
      //       zvd: 'orangery',
      //     },
      //     {
      //       id: 4,
      //       title: 'Піца з морепродуктами 600г',
      //       price: '400 грн',
      //       src: require('../img/morskaya.jpg'),
      //       text: 'Вершки, часник, моцарелла, пармезан, лосось, тунець, креветка тигрова, мідії, маслини',
      //       zvd: 'orangery',
      //     },
      //     {
      //       id: 5,
      //       title: 'Піца делікатесна 550г',
      //       price: '370 грн',
      //       src: require('../img/delikat.jpg'),
      //       text: "Вершки, соус песто, прошутто, груша, томати в'ялені, дорблю, моцарелла, мікс салату, кедровий горіх",
      //       zvd: 'orangery',
      //     },
      //   ],
      // },
      {
        subcategory: 'До пива',
        items: [
          //{
          // id:14,
          //  title:"хамон 50г",
          // price:"99 грн",
          //  src:require('../img/hamon.jpg'),
          //  text:"",
          // zvd: 'orangery',},
          {
            id: 16,
            title: 'Арахіс 50г',
            price: '120 грн',
            src: require('../img/arahis.png'),
            text: '',
            description: ``,
            zvd: 'orangery',
          },
          {
            id: 15,
            title: 'Сухарі Мюнхенські 150/50г',
            price: '150 грн',
            src: require('../img/suhari.jpg'),
            text: 'Хліб бородинський, олія, часник, пармезан, соус Айолі',
            description: `Ароматні хрусткі грінки з Бородинського хліба, обсмажені на рослинній олії з часником, посипані тертим пармезаном і подані з фірмовим соусом айолі. Ідеальна закуска до напоїв або як доповнення до перших страв`,
            zvd: 'room',
          },
          {
            id: 1,
            title: 'фісташки 50г',
            price: '130 грн',
            src: require('../img/fist.png'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 2,
            title: 'чіпси 50г',
            price: '95 грн',
            src: require('../img/chips.png'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 3,
            title: 'В‘ялена курка 50г',
            price: '125 грн',
            src: require('../img/valkurica.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 4,
            title: 'В‘ялена свинина 50г',
            price: '140 грн',
            src: require('../img/valsvin.jpg'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 5,
            title: 'Креветки темпура 180г',
            price: '230 грн',
            src: require('../img/krevetkitempurra.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },

          {
            id: 6,
            title: 'Вуха в соєвому соусі 150г',
            price: '155 грн',
            src: require('../img/vuhavsous.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },
          {
            id: 7,
            title: 'Пекельні вуха 150г',
            price: '155 грн',
            src: require('../img/pekelvuha.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },
          {
            id: 8,
            title: 'Вуха в соусі Sweet Chili 150г',
            price: '155 грн',
            src: require('../img/vuhavsussweet.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },
          {
            id: 10,
            title: 'Тарілка до пива 300г',
            price: '390 грн',
            src: require('../img/tarilkadopiva.jpg'),
            isNew: true,
            text: 'в‘ялена курка, в‘ялена свинина, чіпси, фісташки, арахіс, вуха в соєвому соусі',
            zvd: 'orangery',
          },

          // {
          //     id:11,
          //     title:"Креветки варені 150г NEW",
          //     price:"150 грн",
          //     src: require('../img/krevetkavar.jpg'),
          //     text:"",
          // zvd: 'orangery',},
          {
            id: 12,
            title: 'Цибулеві кільця 150г ',
            price: '160 грн',
            src: require('../img/cibkol.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },
          {
            id: 13,
            title: 'Картопля Фрі 150г ',
            price: '120 грн',
            src: require('../img/frii.jpg'),
            isNew: true,
            text: '',
            zvd: 'orangery',
          },
        ],
      },
      {
        subcategory: 'Десерти',
        items: [
          {
              id:12,
              title:"Солодкий рол «Сансет» 160г",
              price:"270 грн",
              src: require('../img/solodkiysunset.jpg'),
              text:"цитрусовий млинець, крем-сир, цукрова пудра, апельсин, груша, вершки, топінг, пластівці мигдальні",
            description: `Ніжний та освіжаючий десерт, що дарує справжній сонячний настрій. Основа з тонкого цитрусового млинця ідеально поєднується з м’яким вершковим крем-сиром, соковитим апельсином та солодкою грушею. Витончений смак довершують легкі вершки та хрусткі мигдальні пластівці під солодким топінгом.`,
          zvd: 'orangery',},
          {
              id:13,
              title:"Солодкий рол «Шоко-Екзотик» 160г",
              price:"270 грн",
              src: require('../img/solodkiyshoko.jpg'),
              text:"цитрусовий млинець, крем-сир, цукрова пудра, какао, вишня коктейльна, манго, вершки, топінг, пластівці мигдальні.",
            description: `Вишукане поєднання фруктів та шоколадних ноток. Основа з ароматного цитрусового млинця наповнена ніжним крем-сиром, шматочками стиглого манго та солодкими коктейльними вишнями. Завдяки додаванню какао, вершків та мигдалевих пластівців, рол отримує насичений десертний смак`,
          zvd: 'orangery',},
          // {
          //     id:1,
          //     title:"Рол «Екзотик» 200г",
          //     price:"120 грн",
          //     src: require('../img/ekzotik.jpg'),
          //     text:"тісто, крем-сир, банан, ківі, ананас, апельсин, топінг, цукрова пудра",
          // zvd: 'orangery',},
          // {
          //     id:2,
          //     title:"Рол «Мі-мі» 210г",
          //     price:"120 грн",
          //     src:require('../img/mimi.jpg'),
          //     text:"тісто, крем-сир, банан, ківі, мед, апельсин, топінг, цукрова пудра",
          // zvd: 'orangery',},

          // {
          //     id:3,
          //     title:"Рол «Маямі» 250г",
          //     price:"120 грн",
          //     src:require('../img/mayami.jpg'),
          //     text:"тісто, крем-сир, какао, ківі, мараскінова вишня, м’ята, арахіс, ананс, топінг, цукрова пудра",
          // zvd: 'orangery',},
          // {
          //   id: 4,
          //   title: 'Гарбузові панкейки з медом 200г',
          //   price: '120 грн',
          //   src: require('../img/garbuzPankake.jpg'),
          //   text: 'Панкейки з гарбуза, мед, вишня коктейльна, мʼята, цукрова пудра',
          //   zvd: 'orangery',
          //   // energy: true
          // },
          {
            id: 5,
            title: 'pink cheesecake 150г',
            price: '120 грн',
            src: require('../img/cheesecake.jpg'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          // {
          //   id: 6,
          //   title: 'Бабл Фан 280г',
          //   price: '170 грн',
          //   src: require('../img/bublfun.jpg'),
          //   text: 'морозиво, ріжок, аерозольні вершки, арахіс, топінг, печиво «Орео», мараскинова вишня, желе ведмедики',
          //   zvd: 'orangery',
          // },
          //  {
          //id: 7,
          //title: 'Айс Фрут 280г',
          //price: '170 грн',
          //src: require('../img/icefrut.jpg'),
          //text: 'морозиво, мараскинова вишня, ківі, аерозольні вершки, топінг, полуниця, банан',
          //zvd: 'orangery',
          //},

          {
            id: 8,
            title: 'Морозиво 100г',
            price: '90 грн',
            src: require('../img/icee.png'),
            text: '',
            zvd: 'orangery',
            energy: true,
          },
          //           {
          //             id: 9,
          //             title: 'Тірамісу 160г',
          //             price: '150 грн',
          //             src: require('../img/tiramisu.png'),
          //             text: `Крем-сир,
          // Вершки 30%,
          // Цукрова пудра,
          // Печево саваярді,
          // Какао порошок,
          // Віскі,
          // М'ята
          // `,
          //           zvd: 'orangery',},
          {
            id: 10,
            title: 'Тірамісу 160г',
            price: '190 грн',
            src: require('../img/tiramisu.jpg'),
            text: `Крем-сир,
Вершки 30%,
Цукрова пудра,
Печево саваярді,
Какао порошок,
Віскі,
М'ята 
`,
            description: `Класичний італійський десерт, який поєднує в собі м’якість крему та ніжність савоярді. Крем-сир і вершки, збиті до ідеальної текстури, обвивають кожен шматочок печива, яке вбирає аромат віскі і ніжно просочене кавовими нотками. Поверхня посипана какао порошком додає легкий гіркуватий акцент, а м'ята надає свіжості і елегантної завершеності. Це справжнє свято для гурманів, де кожен інгредієнт грає свою роль у створенні бездоганного балансу смаку.`,
            zvd: 'orangery',
            energy: true,
          },
          {
            id: 11,
            title: 'Млинці креп сюзетт 200г',
            price: '260 грн',
            src: require('../img/mlinciKrepSuzett.webp'),
            text: `Апельсин,
олія,
Полуниця свіжа,
Цукор ванільний,
Віскі,
Мигдалеві пластівці,
морозиво,
Пудра цукрова,
М'ята 
`,
            description: `Класика французької кухні, де кожен шматочок розкриває гармонію смаку. Тонкі млинці з ніжною апельсиновою глазур’ю, яка поєднується з легким ванільним цукром і нотками віскі, створюють справжній шедевр. Свіжа полуниця і мигдалеві пластівці додають страві текстурного контрасту, а морозиво пломбір і легка пудра цукрова завершають смакову палітру. Вишукане поєднання гарячого і холодного, цитрусового і солодкого, підкреслене ароматом м’яти.`,
            zvd: 'room',
          },
        ],
      },
    ],
  },
  {
    category: 'Бар',
    subcategories: [
      {
        subcategory: 'НАСТОЯНКИ & АПЕРИТИВИ',
        items: [
          {
            id: 1,
            title: 'Апероль (Італія) 1л',
            price: '1720 грн',
            src: require('../img/aperol.webp'),
            text: '50мл - 86 грн',
          },
          {
            id: 2,
            title: 'Кампарі (Італія) 1л',
            price: '1720 грн',
            src: require('../img/campary.webp'),
            text: '50мл - 86 грн',
          },

          {
            id: 3,
            title: 'Ксента Абсента (Італія) 1л',
            price: '2020 грн',
            src: require('../img/xenta.webp'),
            text: '50мл - 101 грн',
          },
        ],
      },
      {
        subcategory: 'РОМ',
        items: [
          {
            id: 1,
            title: 'Капітан Морган Оріджинал Спайсед Голд (Пуерто-Ріко) 1л',
            price: '2200 грн',
            src: require('../img/kmg.webp'),
            text: '50мл - 110 грн',
          },

          {
            id: 2,
            title: 'Капітан Морган Дарк Ром (Ямайка) 1л',
            price: '2400 грн',
            src: require('../img/kmd.webp'),
            text: '50мл - 120 грн',
          },
        ],
      },
      {
        subcategory: 'ТЕКІЛА',
        items: [
          // {
          //     id:1,
          //     title:"Хосе Куерво Еспешиал Сільвер (Мексика) 1л",
          //     price:"1800 грн",
          //     src: require('../img/jks.webp'),
          //     text:"50мл - 90 грн",
          // },
          // {
          //     id:2,
          //     title:"Хосе Куерво Еспешиал Репосадо (Мексика) 1л",
          //     price:"1800 грн",
          //     src: require('../img/jkg.webp'),
          //     text:"50мл - 90 грн",
          // },
          {
            id: 3,
            title: 'Харана Бланко 100% Блакитна Агава (Мексика) 1л',
            price: '2200 грн',
            src: require('../img/JaranaB.webp'),
            text: '50мл - 110 грн',
          },
          {
            id: 4,
            title: 'Харана Репосадо 100% Блакитна Агава (Мексика) 1л',
            price: '2200 грн',
            src: require('../img/JaranaR.webp'),
            text: '50мл - 110 грн',
          },
        ],
      },
      {
        subcategory: 'ВІСКІ & ТЕННЕССІ',
        items: [
          // {
          //     id:1,
          //     title:"Jameson (Ірландія) 1л",
          //     price:"1800 грн",
          //     src: require('../img/jam.webp'),
          //     text:"50мл - 90 грн",
          // },
          {
            id: 2,
            title: "Белл'с Оріджинал (Шотландія) 1л",
            price: '2000 грн',
            src: require('../img/bels.webp'),
            text: '50мл - 100 грн',
          },
          {
            id: 3,
            title: 'Джонні Уокер Ред Лейбл (Шотландія) 1 л',
            price: '2200 грн',
            src: require('../img/label.webp'),
            text: '50мл - 110 грн',
          },
          {
            id: 4,
            title: 'Джонні Уокер блек Лейбл (Шотландія) 1 л',
            price: '3800 грн',
            src: require('../img/blacklabel.png'),
            text: '50мл - 190 грн',
          },
          // {
          //     id:5,
          //     title:"Джек Деніелс (Теннессі) 1л",
          //     price:"2000 грн",
          //     src: require('../img/jd.webp'),
          //     text:"50мл - 100 грн",
          // },
          {
            id: 6,
            title: 'Джек Деніелс Медовий (Теннессі) 1л',
            price: '3000 грн',
            src: require('../img/jdh.webp'),
            text: '50мл - 150 грн',
          },
          {
            id: 7,
            title: 'Гленморанджі Оріджинал, 10 років (Шотландія) 1л',
            price: '6000 грн',
            src: require('../img/glen.webp'),
            text: '50мл - 300 грн',
          },
          {
            id: 8,
            title: 'Бурбон Буліт (США) 1л',
            price: '2820 грн',
            src: require('../img/bulit.webp'),
            text: '50мл - 141 грн',
          },
          {
            id: 9,
            title: "О'Браєн (Ірландія) 1л",
            price: '2400 грн',
            src: require('../img/obrayen.webp'),
            text: '50мл - 120 грн',
          },
        ],
      },
      {
        subcategory: 'КОНЬЯКИ & БРЕНДІ',
        items: [
          {
            id: 1,
            title: 'Легенда Вірменії**** (Вірменія) 0,5 л',
            price: '900 грн',
            src: require('../img/legenda.webp'),
            text: '50мл - 90 грн',
          },
          {
            id: 2,
            title: 'Коблево ****(Україна) 0,5 л',
            price: '650 грн',
            src: require('../img/koblevo.webp'),
            text: '50мл - 65 грн',
          },
          {
            id: 3,
            title: 'Каноні  Дзвелі  **** (Грузія) 0,5',
            price: '850 грн',
            src: require('../img/kanoni.webp'),
            text: '50мл - 85 грн',
          },
          {
            id: 4,
            title: 'Метакса ***** (Греція) 0,5л',
            price: '1250 грн',
            src: require('../img/metaxa.webp'),
            text: '50мл - 125 грн',
          },
          {
            id: 5,
            title: 'Ремі Мартін VSOP (Франція) 0,5л',
            price: '2400 грн',
            src: require('../img/rmvsop.webp'),
            text: '50мл - 240 грн',
          },
          // {
          //     id:6,
          //     title:"Areni***** (Вірменія) 0,5 л",
          //     price:"600 грн",
          //     src: require('../img/areni.webp'),
          //     text:"50мл - 60 грн",
          // },
        ],
      },
      {
        subcategory: 'ЛІКЕРИ',
        items: [
          {
            id: 5,
            title: 'Бейліз Оріджинал (Ірландія) 1л',
            price: '2000 грн',
            src: require('../img/bail.webp'),
            text: '50мл - 100 грн',
          },
          {
            id: 1,
            title: 'Becherovka (Чехія) 1л',
            price: '1800 грн',
            src: require('../img/beherovka.png'),
            text: '50мл - 90 грн',
          },
          {
            id: 2,
            title: 'Марі Брізар в асортименті (Франція) 0,7л',
            price: '1008 грн',
            src: require('../img/mbl.webp'),
            text: '50мл - 72грн',
          },
          {
            id: 3,
            title: 'Воларе в асортименті (Італія) 0,7л',
            price: '854 грн',
            src: require('../img/volare.webp'),
            text: '50мл - 61грн',
          },
          {
            id: 4,
            title: 'Самбука (Італія) 0,7л',
            price: '1400 грн',
            src: require('../img/sambuka.webp'),
            text: '50мл - 100 грн',
          },
        ],
      },
      {
        subcategory: 'КРИЖАНИЙ ШОТ',
        items: [
          {
            id: 1,
            title: 'Егермайстер (Німеччина) 1л',
            price: '2400 грн',
            src: require('../img/jager.webp'),
            text: '50мл - 120 грн',
          },
        ],
      },
      {
        subcategory: 'ГОРІЛКА',
        items: [
          // {
          //     id:1,
          //     title:"Nemiroff Lex (Україна) 0,5 л",
          //     price:"600 грн",
          //     src: require('../img/lex.webp'),
          //     text:"50мл - 60грн",
          // },
          // {
          //     id:2,
          //     title:"Nemiroff De luxe (Україна) 0,5 л",
          //     price:"500 грн",
          //     src: '',
          //     text:"50мл - 50грн",
          // },
          {
            id: 3,
            title: 'Koskenkorva (Фінляндія) 0,5 л',
            price: '800 грн',
            src: require('../img/kosk.webp'),
            text: '50мл - 80грн',
          },
          //{
          //id:4,
          //title:"Koskenkorva Ginger (Фінляндія) 0,5 л",
          //price:"550 грн",
          //src: require('../img/kosk.webp'),
          //text:"50мл - 55грн",
          //},
          {
            id: 5,
            title: 'Перша Гільдія Поважна (Україна) 0,5 л',
            price: '500 грн',
            src: require('../img/persha.webp'),
            text: '50мл - 50 грн',
          },
          {
            id: 6,
            title: 'Zubrowka Biala (Польша) 0,5л',
            price: '600 грн',
            src: require('../img/zubrovka.webp'),
            text: '50мл - 60 грн',
          },
        ],
      },
      {
        subcategory: 'ДЖИН',
        items: [
          {
            id: 1,
            title: "Гордон'с Лондон Драй (Великобританія) 1л",
            price: '2400 грн',
            src: require('../img/gordons.webp'),
            text: '50мл - 120 грн',
          },
          {
            id: 2,
            title: 'гордон`c середземноморський апельсин (Великобританія) 1л',
            price: '2600 грн',
            src: require('../img/ginorange.webp'),
            text: '50мл - 130 грн',
          },
        ],
      },
      {
        subcategory: 'ВЕРМУТИ',
        items: [
          {
            id: 1,
            title: 'Martini Extra Dry (Італія) 1 л',
            price: '1220 грн',
            src: require('../img/MartiniExtraDry.png'),
            text: '100мл - 121 грн',
          },
          {
            id: 2,
            title: 'Cinzano Rosso (Італія) 1 л',
            price: '1400 грн',
            src: require('../img/CinzanoRosso.png'),
            text: '100мл - 140 грн',
          },
          {
            id: 3,
            title: 'Cinzano Bianco (Італія) 1 л',
            price: '1400 грн',
            src: require('../img/CinzanoBianco.png'),
            text: '100мл - 140 грн',
          },
        ],
      },
      {
        subcategory: 'ШАМПАНСЬКЕ & ІГРИСТІ ВИНА',
        items: [
          {
            id: 11,
            title: 'Просеко кег 200 мл',
            price: '150 грн',
            src: require('../img/prossecoKeg.png'),
            text: '',
          },
          // {
          //   id: 1,
          //   title: 'Моет і Шандон Імперіаль (Франція) ігр.,брют біле 0,75л',
          //   price: '2915 грн',
          //   src: require('../img/moet.webp'),
          //   text: ``,
          // },
          // {
          //   id: 2,
          //   title: 'Асті Мартіні (Італія) 0,75 л',
          //   price: '950 грн',
          //   src: require('../img/asti.webp'),
          //   text: ``,
          // },
          {
            id: 3,
            title:
              'Терра Серена Просекко Фрізанте (Італія) ігристе, біл./сух. 0,75л',
            price: '720 грн',
            src: require('../img/proseco.webp'),
            text: '200мл - 192грн',
          },
          {
            id: 4,
            title: 'Фрізанте Пью Терра Серена 1881 (Італія) біл н/сух 0,75',
            price: '660 грн',
            src: require('../img/proseco1881.png'),
            text: '200мл - 176 грн',
          },
          {
            id: 5,
            title: 'САН МАРЕ ФРАГОЛІНО (ІТАЛІЯ) НАПІВСОЛ./БІЛ. 0,75 Л',
            price: '465 грн',
            src: require('../img/fragolinob.webp'),
            text: '200мл - 128 грн',
          },
          {
            id: 6,
            title: 'Сан Маре Фраголіно Россо (Італія) сол./чер. 0,75 л',
            price: '465 грн',
            src: require('../img/fragolinor.webp'),
            text: '200мл - 128грн',
          },
          {
            id: 7,
            title: 'Сан Маре Фраголіно Персик (Італія) напівсол./біл. 0,75 л',
            price: '465 грн',
            src: require('../img/pesca.png'),
            text: '200мл - 128грн',
          },
          {
            id: 8,
            title: 'Marengo Brut (Україна) сух./біл. 0,75л',
            price: '480 грн',
            src: require('../img/marengob.webp'),
            text: '200мл - 128 грн',
          },
          {
            id: 9,
            title: 'Маренго рожеве напівсолодке (Україна) напівсол./рож. 0,75л',
            price: '480 грн',
            src: require('../img/mangor.webp'),
            text: '200мл - 128 грн',
          },
          {
            id: 10,
            title:
              'Латініум Спарклінг (Німеччина) ігристе, біл./напівсол. 0,75л',
            price: '465 грн',
            src: require('../img/sparkling.webp'),
            text: '200мл - 128',
          },
        ],
      },
      {
        subcategory: 'ВИНА',
        items: [
          {
            id: 1,
            title: 'Geo Алазанська долина (Грузія) черв./напівсол. 0,75 л',
            price: '600 грн',
            src: require('../img/alazKrasn.webp'),
            text: '200мл - 160 грн',
          },
          {
            id: 2,
            title: 'Geo Алазанська долина (Грузія) біл./напівсол. 0,75 л',
            price: '600 грн',
            src: require('../img/alazBel.webp'),
            text: '200мл - 160 грн',
          },
          {
            id: 3,
            title: 'Geo Сапераві (Грузія) черв./сух. 0,75л',
            price: '600 грн',
            src: require('../img/alazKrasn.webp'),
            text: '200мл - 160 грн',
          },
          {
            id: 4,
            title: 'Терра Італіаніка Б’янко (Італія) біл./напівсол. 0,75л',
            price: '510 грн',
            src: require('../img/terrab.webp'),
            text: '200мл - 136 грн',
          },
          {
            id: 5,
            title: 'Терра Італіаніка Россо (Італія) черв./напівсол. 0,75л',
            price: '510 грн',
            src: require('../img/terrar.webp'),
            text: '200мл - 136 грн',
          },
          {
            id: 6,
            title: 'Сеттесолі Піно Гріджіо (Італія) біл./сух. 0,75л',
            price: '660 грн',
            src: require('../img/setesollipino.webp'),
            text: '200мл - 176 грн',
          },
          // {
          //   id: 7,
          //   title: 'Сеттесолі Неро д’Авола (Італія)черв./сух. 0,75л',
          //   price: '660 грн',
          //   src: require('../img/setesollikr.webp'),
          //   text: '200мл - 176 грн',
          // },
          {
            id: 8,
            title: 'Латініум Ріслінг (Німеччина) біл./напівсол. 0,75 л',
            price: '510 грн',
            src: require('../img/latin.webp'),
            text: '200мл - 136 грн',
          },
          {
            id: 9,
            title: 'Коблево Піно Гріджіо (Україна) біл./сух. 0,75л',
            price: '465 грн',
            src: require('../img/koblevowitewine.webp'),
            text: '200мл - 124 грн',
          },
          {
            id: 10,
            title: 'Коблево Мерло (Україна) черв./сух. 0,75л',
            price: '465 грн',
            src: require('../img/kobmerlo.webp'),
            text: '200мл - 124 грн',
          },
          {
            id: 11,
            title:
              'Mud House Marlborough savignon blanc (Нова Зеландія) біл./сух. 0,75л',
            price: '1200 грн',
            src: require('../img/MudHouse.png'),
            text: '200мл - 320 грн',
          },
          {
            id: 12,
            title: 'Кампіроса luminate dino (Італія) рож./сух. 0,75л',
            price: '750 грн',
            src: require('../img/kampirosa.webp'),
            text: '200мл - 200 грн',
          },
          // {
          //   id: 13,
          //   title: 'бардоліно ессере Cesari (Італія) чер./сух. 0,75л',
          //   price: '750 грн',
          //   src: require('../img/bardolino.webp'),
          //   text: '200мл - 200 грн',
          // },
          {
            id: 14,
            title: 'sant orsola (Італія) біл./напівсол. 0,75л',
            price: '600 грн',
            src: require('../img/santOrsola.webp'),
            text: '200мл - 160 грн',
          },
          {
            id: 15,
            title:
              'Marlborough sun savignon blanc (Нова Зеландія) біл./сух. 0,75л',
            price: '1200 грн',
            src: require('../img/malboroSun.webp'),
            text: '200мл - 320 грн',
          },
        ],
      },
      {
        subcategory: 'ПИВО',
        items: [
          // {
          //     id:1,
          //     title:"Kronenbourg Blanc (Франція) кегове",
          //     src: require('../img/kron.webp'),
          //     price:"0,5л - 69 грн",
          //     price2:"0,3л - 45 грн",
          //     text:"",
          // },
          // {
          //     id:1,
          //     title:"Хмелевус вайс (Україна) кегове",
          //     src: require('../img/hmelevus.webp'),
          //     price:"0,5л - 65 грн",
          //     price2:"0,3л - 45 грн",
          //     text:"",
          // },
          {
            id: 2,
            title: 'Lowenbrau original (Німеччина) кегове',
            src: require('../img/lowenbrau.webp'),
            price: '0,5л - 95 грн',
            price2: '0,3л - 70 грн',
            text: ``,
          },
          {
            id: 3,
            title: 'Чернігівське Біле (Україна) кегове',
            price: '0,5л - 90 грн',
            price2: '0,33л - 65 грн',
            src: require('../img/beloe.webp'),
            text: ``,
          },
          {
            id: 3,
            title: 'Повна Діжка (Україна) кегове',
            price: '0,5л - 90 грн',
            price2: '0,33л - 65 грн',
            src: require('../img/dizhka.png'),
            text: ``,
          },
          // {
          //{
          //id:5,
          //title:"Hoegaarden (Бельгія) пляшкове 0,33",
          //price:"89 грн",
          //src: require('../img/hoegarden.webp'),
          //text:"",
          // },
          {
            id: 6,
            title: 'Leffe Brune (Бельгія) бут. 0,33л',
            price: '150 грн',
            src: require('../img/lefe.webp'),
            text: ``,
          },
          {
            id: 7,
            title: 'Corona Extra (Mexico) пляшкове 0,355',
            price: '150 грн',
            text: ``,
            src: require('../img/corona.webp'),
          },

          {
            id: 10,
            title: 'Corona Extra 0.0 (Mexico) пляшкове 0,355',
            price: '150 грн',
            src: require('../img/coronaba.png'),
            text: '',
          },
          // {
          //     id:6,
          //     title:"Carlsberg (Данія)(Б/А) пляшкове 0,5л",
          //     price:"65 грн",
          //     src: require('../img/carlnon.webp'),
          //     text:"",
          // },
          {
            id: 8,
            title: 'Стелла артуа (Бельгія)(Б/А) пляшкове 0,33',
            price: '100 грн',
            src: require('../img/stellagb.webp'),
            text: ``,
          },
        ],
      },
      {
        subcategory: 'ЕНЕРГЕТИК',
        items: [
          {
            id: 1,
            title: 'Red Bull 0,25л',
            price: '120 грн',
            src: require('../img/redbull.webp'),
            text: ``,
          },
          {
            id: 2,
            title: 'Red Bull tropical 0,25л',
            price: '120 грн',
            src: require('../img/rby.webp'),
            text: ``,
          },
          {
            id: 3,
            title: 'Red Bull sugarfree 0,25л',
            price: '120 грн',
            src: require('../img/rbws.webp'),
            text: ``,
          },
        ],
      },
      {
        subcategory: 'КАВА',
        items: [
          {
            id: 1,
            title: 'Еспрессо 0,030л',
            price: '40 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 2,
            title: 'Амерікано 0,120л',
            price: '40 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },

          {
            id: 3,
            title: 'Капучино 0,160л',
            price: '65 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 4,
            title: 'Капучино з карамельною коркою 0,160л',
            price: '95 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 5,
            title: 'Латте 0,200л',
            price: '65 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 10,
            title: 'Еспрессо-тонік 0.250л',
            price: '75 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 6,
            title: 'айс Латте 0,200л',
            price: '75 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          {
            id: 7,
            title: 'Флет вайт 0,250л',
            price: '80 грн',
            src: require('../img/cof.webp'),
            text: ``,
          },
          // {
          //   id: 8,
          //   title: 'раф 0,250л',
          //   price: '120 грн',
          //   src: require('../img/cof.webp'),
          //   text: '',
          // },
          {
            id: 10,
            title: 'Бамбл кава 0,250л',
            price: '85 грн',
            src: require('../img/cof.webp'),
            text: `сік, кава, сироп в асортименті`,
          },
          {
            id: 9,
            title: 'какао 0,250л',
            price: '65',
            src: require('../img/cof.webp'),
            text: '',
          },
        ],
      },

      {
        subcategory: 'ЛИМОНАДИ',
        items: [
          {
            id: 1,
            title: 'манго-маракуйя 350мл',
            price: '150 грн',
            src: require('../img/mangomarak.jpg'),
            text: `Пюре манго, сироп маракуйя, сік ананас, сік лимон, 7-up`,
          },
          {
            id: 2,
            title: 'огірковий 350мл',
            price: '135 грн',
            src: require('../img/lenOgur.webp'),
            text: `Огірок,
Сік лимон,
7ап,
Лайм`,
          },
          {
            id: 3,
            title: 'малиновий 350мл',
            price: '150 грн',
            src: require('../img/lemMalina.webp'),
            text: `Пюре малини,
7ап,
Сік лимон,
Сік ананас`,
          },
          {
            id: 4,
            title: 'полуничний 350мл',
            price: '150 грн',
            src: require('../img/lemPolGru.webp'),
            text: `Пюре полуниці,
7ап,
Сік ананас`,
          },
          {
            id: 5,
            title: 'персиковий 350мл',
            price: '150 грн',
            src: require('../img/lemPersik.webp'),
            text: `Пюре персик,
тонік,
Сік персик`,
          },
          {
            id: 6,
            title: 'цитрусовий 350мл',
            price: '135 грн',
            src: require('../img/lemCitr.webp'),
            text: `апельсин, лимон, лайм, сік, мінеральна вода`,
          },
          // {
          //   id: 7,
          //   title: `імбирно-м'ятний 350мл`,
          //   price: '135 грн',
          //   src: require('../img/lemImbMyata.webp'),
          //   text: `імбир, м'ята, лимонний сік, 7ап`,
          // },
        ],
      },

      {
        subcategory: 'НАПОЇ',
        items: [
          {
            id: 1,
            title: 'Сік 0,95л',
            price: '275 грн',
            src: require('../img/sandora.webp'),
            text: '200мл - 55 грн',
            zvd: 'room',
          },
          {
            id: 2,
            title: '7UP 0.5 л',
            price: '70 грн',
            src: require('../img/up.webp'),
            text: ``,
            zvd: 'room',
          },
          {
            id: 3,
            title: 'Пепсі 0.33 л',
            price: '80 грн',
            src: require('../img/pepsi.webp'),
            text: ``,
            zvd: 'room',
          },
          // {
          //     id:4,
          //     title:"Пепсі 1 л",
          //     price:"110 грн",
          //     src: require('../img/pepsil.webp'),
          //     text:"200мл - 20грн",
          // },
          // {
          //   id: 5,
          //   title: 'Моршинська газ. 0,5 л',
          //   price: '59 грн',
          //   src: require('../img/morshs.webp'),
          //   text: ``,
          // },
          // {
          //   id: 6,
          //   title: 'Моршинська негаз. 0,5 л',
          //   price: '59 грн',
          //   src: require('../img/morshnon.webp'),
          //   text: ``,
          // },
          {
            id: 7,
            title: 'Моршинська газ. 0,33 л',
            price: '85 грн',
            src: require('../img/morshs.webp'),
            text: ``,
            zvd: 'room',
          },
          {
            id: 8,
            title: 'Моршинська негаз. 0,33 л',
            price: '85 грн',
            src: require('../img/morshnon.webp'),
            text: ``,
            zvd: 'room',
          },
          {
            id: 9,
            title: 'Боржомі 0,5л',
            price: '100 грн',
            src: require('../img/borj.webp'),
            text: ``,
            zvd: 'room',
          },
          {
            id: 10,
            title: 'Швепс тонік  0.75л',
            price: '120 грн',
            src: require('../img/tonic.png'),
            text: '',
            zvd: 'room',
          },
          {
            id: 11,
            title: 'Швепс тонік  0.33л',
            price: '80 грн',
            src: require('../img/Schweppes033.png'),
            text: '',
            zvd: 'orangery',
          },
          {
            id: 12,
            title: 'Mirinda 0,5 л',
            price: '70 грн',
            src: require('../img/mirinda.webp'),
            text: '',
            zvd: 'room',
          },
        ],
      },
      {
        subcategory: 'ФРЕШІ',
        items: [
          {
            id: 1,
            title: 'апельсин 200мл',
            price: '150 грн',
            src: '',
            text: ``,
          },
          // {
          //   id: 2,
          //   title: 'Грейпфрут 200мл',
          //   price: '120 грн',
          //   src: '',
          //   text: ``,
          // },
          // {
          //   id: 3,
          //   title: 'Грейпфрут-апельсин 200мл',
          //   price: '120 грн',
          //   src: '',
          //   text: ``,
          // },
          // {
          //   id: 4,
          //   title: 'Лайм-лимон 200мл',
          //   price: '120 грн',
          //   src: '',
          //   text: ``,
          // },
        ],
      },
      {
        subcategory: 'ЧАЙ',
        items: [
          {
            id: 7,
            title: 'Чорний 0,450л',
            price: '70 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 8,
            title: 'Зелений 0,450л',
            price: '70 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 9,
            title: 'Ерл грей 0,450л',
            price: '70 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 12,
            title: '«Нахабний фрукт» 0,450л',
            price: '70 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 2,
            title: 'Альпійський луг 0,450л',
            price: '85 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 5,
            title: 'суниця з вершками 0,450л',
            price: '80 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 6,
            title: 'бризки шампанського 0,450л',
            price: '85 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
        ],
      },
      {
        subcategory: 'Натуральні чаї maribell',
        items: [
          {
            id: 1,
            title: 'Яблуко-кориця 0.450 мл',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 2,
            title: 'Журавлина-апельсин 0,450л',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 3,
            title: 'Обліпиха-чабрець 0,450л',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 4,
            title: 'Ягідний з імбирем 0,450л',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 5,
            title: 'Обліпиха-апельсин-кориця 0,450л',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
          {
            id: 6,
            title: 'Манго-маракуя 0,450л',
            price: '100 грн',
            src: require('../img/tea.webp'),
            text: ``,
          },
        ],
      },
      {
        subcategory: 'Зігріваючі напої',
        items: [
          {
            id: 1,
            title: 'червоний Глінтвейн 0,300л',
            price: '140',
            src: '',
            text: `вино, сік, кориця, палички кориці, мед, гвоздика`,
          },
          {
            id: 2,
            title: 'білий Глінтвейн 0,300л',
            price: '140 грн',
            src: '',
            text: `вино, сік, кориця, палички кориці, мед, гвоздика`,
          },
          // {
          //   id: 3,
          //   title: 'мандариновий Глінтвейн 0,300л',
          //   price: '110 грн',
          //   src: '',
          //   text: `вино, сік, мандарин, кориця, палички кориці, мед, гвоздика`,
          // },
          {
            id: 4,
            title: 'Безалкогольний білий глінтвейн 0,300л',
            price: '130 грн',
            src: '',
            text: `сік, кориця, палички кориці, мед, гвоздика`,
          },
          {
            id: 5,
            title: 'Безалкогольний червоний глінтвейн 0,300л',
            price: '130 грн',
            src: '',
            text: `сік, кориця, палички кориці, мед, гвоздика`,
          },
          // {
          //   id: 6,
          //   title: 'Безалкогольний мандариновий Глінтвейн 0,300л',
          //   price: '110 грн',
          //   src: '',
          //   text: `сік, мандарин, кориця, палички кориці, мед, гвоздика`,
          // },
        ],
      },
    ],
  },
  {
    category: 'Коктейлі',
    subcategories: [
      {
        subcategory: 'Клаcика',
        items: [
          {
            id: 31,
            title: 'Porn Star Martini 150 мл',
            price: '290 грн',
            src: require('../img/pornstar.jpg'),
            text: 'горілка Absolut Vanilla, пюре маракуйя, лікер triple sec, фреш лимону, сироп цукровий, просеко',
          },
          {
            id: 32,
            title: 'Бетон 250 мл',
            price: '180 грн',
            src: require('../img/fayniyjin.jpg'),
            text: 'Бехеровка, тонік, апельсин',
          },
          // {
          //   id: 1,
          //   title: 'Mimosa 180мл',
          //   price: '205 грн',
          //   text: `Апельсиновий фреш, просекко`,
          //   src: require('../img/mimoza.jpg'),
          //   description: `це елегантний і легкий коктейль, який поєднує в собі ігристу радість шампанського та свіжу соковитість апельсинового соку. `,
          // },
          // {
          //   id: 2,
          //   title: 'Bellini 180мл',
          //   price: '210 грн',
          //   text: `пюре персик, просеко`,
          //   src: require('../img/Bellini.jpg'),
          //   description: `це втілення ніжності та витонченості у келиху. Цей класичний італійський коктейль поєднує освіжаючу легкість ігристого вина Просекко з оксамитовою солодкістю персикового пюре`,
          // },
          {
            id: 3,
            title: 'French75 150мл',
            price: '250 грн',
            text: `Джин гордонс,
Просеко,
цукровий сироп,
фреш лимону`,
            src: require('../img/French75.jpg'),
            description: `це вишуканий і зухвалий коктейль, що поєднує в собі свіжість, витонченість та легкий шарм французького стилю. Створений для справжніх поціновувачів класики, він поєднує сухий джин із яскравою кислинкою свіжовичавленого лимонного соку, делікатною солодкістю цукрового сиропу та ігристим акцентом шампанського`,
          },
          //           {
          //             id: 4,
          //             title: 'Penicillin 150мл',
          //             price: '295 грн',
          //             text: `Буллет,
          // Сироп імбир мед,
          // фреш лимону,
          // Апельсин`,
          //             src: require('../img/Penicillin.jpg'),
          //             description: `це сучасна класика, що поєднує силу, глибину і теплу пряність у кожному ковтку. Цей коктейль — справжній еліксир для душі, який грає контрастами та балансом. Основою є насичений бурбон який підкреслюється свіжістю лимонного соку та медово-імбирним сиропом, що додає напою приємного пряного тепла й м’якої солодкості.`,
          //           },
          {
            id: 5,
            title: 'whiskay sour 200мл',
            price: '295 грн',
            text: `Буллет,
фреш лимону,
Сироп цукровий,
Ease Foam,
Ангустура`,
            src: require('../img/Whiskeysour.jpg'),
            description: `це коктейль, що поєднує у собі класичну гіркоту віскі з приємною кислинкою лимона та ніжною солодкістю, створюючи збалансований і освіжаючий напій. Його простота і глибина смаку роблять його ідеальним для будь-якої нагоди`,
          },
          {
            id: 6,
            title: 'Mai-Tai 200мл',
            price: '280 грн',
            text: `ром чорний
Лікер трипл сек,
Сироп цукровий,
Лікер амарето,
фреш лайму,
М'ята`,
            src: require('../img/MaiTai.jpg'),
            description: `це справжній ковток тропіків, що переносить вас на сонячний пляж з білим піском та легким бризом. Цей культовий коктейль є втіленням екзотики та гармонії смаків, де кожен інгредієнт додає свою неповторну нотку.
Основою є ароматний темний і світлий ром, що надає напою глибини та легкого карибського характеру. Свіжий лаймовий сік додає кислинки, а мигдальний сироп оргеат привносить тонку солодкість з горіховим відтінком. Апельсиновий лікер завершує композицію, додаючи цитрусової яскравості, що балансує весь букет.`,
          },
          //           {
          //             id: 7,
          //             title: 'absent sour 150мл',
          //             price: '225 грн',
          //             text: `Абсент,
          // Сироп цукровий,
          // Ease Foam,
          // фреш лимону`,
          //             src: require('../img/Absentsour.jpg'),
          //             description: `це інтригуючий і вишуканий коктейль, що поєднує класичну кислинку з анісовою загадковістю абсенту. Цей напій зачаровує вже з першого погляду своєю ніжною, пінною текстурою, що увінчує келих, а аромат пробуджує цікавість і злегка п’янить`,
          //           },
//           {
//             id: 8,
//             title: 'martini royal 200мл',
//             price: '280 грн',
//             text: `ЧІНЗАНО Б'ЯНКО,
// Просеко,
// Лайм,
// Мята`,
//             src: require('../img/MartiniRoyal.jpg'),
//             description: `це вишуканий і освіжаючий коктейль, який поєднує в собі легкість і шарм італійського аперитиву. Це ідеальний баланс елегантності та простоти, де класичний вермут Martini Bianco зустрічається з ігристим вином Prosecco, створюючи неповторний смак і легку атмосферу свята`,
//           },
//           {
//             id: 9,
//             title: 'ginger passion 150мл',
//             price: '225 грн',
//             text: `ром золотий,
// Сироп цукровий,
// імбир,
// Пюре маракуйя,
// фреш лайму`,
//             src: require('../img/Gingerpassion.jpg'),
//             description: `це яскравий і екзотичний коктейль, який поєднує в собі свіжість тропіків та пікантну пряність імбиру. Кожен ковток — це справжній вибух смаків, що миттєво бадьорить і освіжає, ніби подорож на сонячний острів.`,
//           },
//           {
//             id: 10,
//             title: 'strawberry daiquiri 150мл',
//             price: '235 грн',
//             text: `ром золотий,
// Пюре полуничне,
// фреш лайму`,
//             src: require('../img/StrawberryDaiquiri.jpg'),
//             description: `це справжній символ літа у келиху, що поєднує свіжість соковитої полуниці з приємною прохолодою і тропічною ноткою. Цей коктейль — легкий, яскравий і спокусливо солодкий, ніби стиглі ягоди, щойно зібрані під теплим сонцем`,
//           },
          //           {
          //             id: 11,
          //             title: 'old fashioned 150мл',
          //             price: '295 грн',
          //             text: `Буллет,
          // Ангустура,
          // коричневий цукор,
          // Вишня коктейльна,
          // Апельсин`,
          //             src: require('../img/oldfashion.jpg'),
          //             description: `це позачасова класика, яка втілює суть елегантності та простоти.
          // Основою є бурбон , чий багатий смак огортається легким дотиком цукру, що додає м’якості, та кількома краплями ароматного бітера, який привносить складні пряні ноти. Невеликий штрих апельсинової цедри надає напою делікатної цитрусової свіжості, а великий шматок кришталево чистого льоду дозволяє коктейлю розкриватися повільно й благородно`,
          //           },
          {
            id: 12,
            title: 'chupa-chups 200мл',
            price: '215 грн',
            text: `Лікер трипл сек,
Сироп кориця,
Лайм,
Апельсин,`,
            src: require('../img/ChupaChups.jpg'),
            description: `е коктейль, що переносить у дитинство, нагадавши смак улюблених льодяників. Яскравий, солодкий та веселий, він поєднує яскраві фруктові ноти створюючи справжнє свято смаку`,
          },
          {
            id: 13,
            title: 'pink lady 150мл',
            price: '230 грн',
            text: `Джин,
вершки,
Сироп грінадін,
фреш лимону,
Ease Foam`,
            src: require('../img/Pinklady.jpg'),
            description: `це коктейль, що втілює елегантність та витонченість у кожному ковтку. Його ніжно-рожевий відтінок і легкий, фруктовий аромат одразу створюють атмосферу романтики і класичного шарму`,
          },
          {
            id: 14,
            title: 'cucumber deer 250мл',
            price: '215 грн',
            text: `Егермейстер,
7ап,
огірок`,
            src: require('../img/Cucumberdeer.jpg'),
            description: `Цей коктейль — справжнє відкриття для тих, хто любить свіжість і неперевершену легкість`,
          },
          {
            id: 15,
            title: 'strawberry cream 250мл',
            price: '275 грн',
            text: `Ром,
Сік ананас,
Пюре полуниця,
вершки`,
            src: require('../img/Strawberrycream.jpg'),
            description: `це коктейль, що переносить у тропічний рай з кожним ковтком. В основі цього напою — ароматний ром, що чудово поєднується з соковитим ананасовим соком, даруючи коктейлю тропічну свіжість та енергію. Пюре з полуниць додає напою соковитої ягідної солодкості і насиченого червоного кольору, а вершки м’яко обвивають смак, роблячи текстуру ніжною та оксамитовою`,
          },
          {
            id: 16,
            title: 'mojito 300мл',
            price: '215 грн',
            text: `Ром золотий,
Моршинська,
М'ята,
Лайм,
коричневий цукор`,
            src: require('../img/Mojito.jpg'),
            description: `це коктейль, який не потребує зайвих слів, адже він вже сам по собі є символом свіжості та легкості. Кожен ковток — це спалах прохолоди, що дарує поєднання м’яти, лайму, білого рому і легкого солодкого акценту`,
          },
          {
            id: 17,
            title: 'Clover club 150мл',
            price: '300 грн',
            text: `джин,
Пюре малини,
Лайм,
Ease Foam`,
            src: require('../img/CloverClub.jpg'),
            description: `це коктейль, що втілює елегантність і витонченість у кожному ковтку. Легкий і збалансований, він поєднує свіжість малини з ніжною текстурою яєчного білка та делікатною основою з джину`,
          },
          //           {
          //             id: 18,
          //             title: 'boulevardier 150мл',
          //             price: '255 грн',
          //             text: `Буллет,
          // Кампарі,
          // ЧІНЗАНО РОССО`,
          //             src: require('../img/Boulevardier.jpg'),
          //             description: `це вишуканий коктейль, що поєднує у собі глибину та елегантність. Своїм смаком він нагадує класичний Negroni, але з більш насиченим і теплим відтінком завдяки використанню бурбону замість джину`,
          //           },
          {
            id: 19,
            title: 'aperol spritz 250мл',
            price: '295 грн',
            text: `Апероль,
Просеко,
мінеральна вода,
Апельсин`,
            src: require('../img/AperolSpritz.jpg'),
            description: `це легкий, яскравий коктейль, що немов створений для літніх вечорів і сонячних днів. Він поєднує в собі освіжаючі і цитрусові ноти аперолю з ігристістю просекко та легким гіркуватим післясмаком, що робить кожен ковток чудово збалансованим і пікантним`,
          },
//           {
//             id: 20,
//             title: 'peach daiquiri 150мл',
//             price: '285 грн',
//             text: `золотий ром,
// Персикове пюре,
// фреш лайму`,
//             src: require('../img/PeachDaiquiri.jpg'),
//             description: `це коктейль, який дарує справжнє відчуття літа в кожному ковтку. Соковита персикова нотка в поєднанні з ніжним ромом створює ідеальний баланс солодкості і фруктової свіжості`,
//           },
//           {
//             id: 21,
//             title: 'strawberry margarita 150мл',
//             price: '265 грн',
//             text: `Текіла Харяна б'янко,
// Лікер тріпл сек,
// полуничне пюре,
// фреш лайму`,
//             src: require('../img/StrawberryMargarita.jpg'),
//             description: `це освіжаючий коктейль, який поєднує в собі яскраву солодкість полуниці та пікантну кислинку лайму, створюючи справжній смак літа в кожному ковтку. Цей коктейль подарує вам поєднання фруктових нот та легкості, що просто тане на язику`,
//           },
          {
            id: 22,
            title: 'Піч Апероль 250мл',
            price: '280 грн',
            src: require('../img/peachAper.jpg'),
            text: 'апероль, персиковий сироп, фраголіно',
          },
          {
            id: 23,
            title: 'Рафаелло 200мл',
            price: '235 грн',
            src: require('../img/raf.jpg'),
            text: 'лікер бейліз , лікер кокос, сироп ванільний, вершки, кокосова стружка ',
          },
          {
            id: 24,
            title: 'Джангл джус 250мл',
            price: '250 грн',
            src: require('../img/jungl.jpg'),
            text: 'джин, лікер пізан, сік апельсиновий, сік ананасовий, апельсин',
          },
          {
            id: 25,
            title: 'Текіла Санрайз 250мл',
            price: '210 грн',
            src: require('../img/teksunr.jpg'),
            text: 'текіла, сік апельсиновий, сироп гренадін, апельсин',
          },
          {
            id: 26,
            title: 'Лонг Айленд Айс Ті 400мл',
            price: '280 грн',
            src: require('../img/long.jpg'),
            text: 'горілка, лікер апельсиновий, джин, ром золотий, пепсі',
          },
          {
            id: 27,
            title: 'Джин-тонік 250мл',
            price: '180 грн',
            src: require('../img/ginton.jpg'),
            text: 'джин, тонік Евересс, лайм',
          },
          {
            id: 28,
            title: 'Куба Лібре 250мл',
            price: '180 грн',
            src: require('../img/kuba.jpg'),
            text: 'ром, лайм, пепсі',
          },
          {
            id: 29,
            title: 'Негроні 100мл',
            price: '250 грн',
            src: require('../img/negr.jpg'),
            text: 'ЧІНЗАНО РОССО, джин, Кампарі, апельсин',
          },
          {
            id: 30,
            title: 'Пінья Колада 300мл',
            price: '240 грн',
            src: require('../img/kolada.jpg'),
            text: 'ром золотий, лікер кокосовий, сироп кокосовий,сік ананасовий, вершки, вишня',
          },
        ],
      },
      {
        subcategory: 'Авторські коктейлі',
        items: [
          {
            id: 11,
            title: 'What is love 150мл',
            price: '200 грн',
            text: `Лікер амарето ,просеко , персиковий сироп, яблучний сік`,
            src: require('../img/Whatislove.jpg'),
            description: ``,
            isNew: true,
            zvd: `orangery`,
          },
          {
            id: 1,
            title: 'Solar kiss 300мл',
            price: '265 грн',
            text: `Лікер тріпл сек, Апероль, сік ананас, сік лимон, сироп маракуйя, пюре манго`,
            src: require('../img/Solarkiss.jpg'),
            description: ``,
            isNew: true,
            zvd: `orangery`,
          },
          {
            id: 2,
            title: 'Midnight gold 300мл',
            price: '265 грн',
            text: `Ром золотий, Бейліс, сироп ванільний, еспрессо, шоколадна крихта`,
            src: require('../img/Midnightgold.jpg'),
            description: ``,
            isNew: true,
            zvd: `orangery`,
          },
          {
            id: 3,
            title: 'Манстера 300мл',
            price: '210 грн',
            text: `ром золотий, сироп кавуновий, лімончелло, 7ап`,
            src: require('../img/manstera.jpg'),
            description: ``,
          },
          {
            id: 4,
            title: 'Фламінго Оранжа 300мл',
            price: '240 грн',
            text: `гордон'c середземноморський апельсин, сік ананасовий, сироп малиновий`,
            src: require('../img/flamingoOr.jpg'),
            description: ``,
          },
          {
            id: 5,
            title: 'Файний джин 250мл',
            price: '220 грн',
            text: `гордон'c середземноморський апельсин, тонік, апельсин`,
            src: require('../img/fayniyjin.jpg'),
            description: ``,
          },
          {
            id: 6,
            title: 'Пекельна мала 350мл',
            price: '240 грн',
            src: require('../img/manstera.jpg'),
            text: 'гордон`c середземноморський апельсин, лимонний сік, сироп гренадін',
            description: ``,
          },
          {
            id: 7,
            title: 'Зелена Фея 450мл',
            price: '280 грн',
            src: require('../img/feya.jpg'),
            text: 'горілка, ром золотий, лікер динний, Ред Бул ',
            description: ``,
          },
          {
            id: 8,
            title: 'Оргазм Тарзана 350мл',
            price: '235 грн',
            src: require('../img/orgazm.jpg'),
            text: 'горілка, лікер динний, сироп блю кюрасао, сік ананасовий',
            description: ``,
          },
          {
            id: 9,
            title: 'Бабл Тедді 350мл',
            price: '230 грн',
            src: require('../img/teddy.jpg'),
            text: 'горілка, лікер білий какао, сироп бабл гам, фреш лимон, сироп кавуновий желейні ведмедики, 7up',
            description: ``,
          },
          {
            id: 10,
            title: 'Оранжерея 300мл',
            price: '220 грн',
            src: require('../img/orangery.jpg'),
            text: 'ром золотий, сироп полуничний, фреш лимон, сік ананасовий',
            description: ``,
          },
        ],
      },
      {
        subcategory: 'Мілкшейк',
        items: [
          {
            id: 1,
            title: 'snickers  250мл',
            price: '180 грн',
            src: require('../img/milkshake.jpg'),
            text: 'морозиво, молоко, арахіс, какао, сироп карамельний, вершки кондитерські',
          },
          {
            id: 2,
            title: 'baunti 250мл',
            price: '180 грн',
            src: require('../img/milkshake.jpg'),
            text: 'морозиво, молоко, какао, кокосова стружка, вершки кондитерські',
          },
          {
            id: 3,
            title: 'raspberry milkshake 250мл',
            price: '180 грн',
            src: require('../img/milkshake.jpg'),
            text: 'морозиво, молоко, топінг, вершки кондитерські',
          },
          {
            id: 4,
            title: 'mango milkshake 250мл',
            price: '180 грн',
            src: require('../img/milkshake.jpg'),
            text: 'морозиво, молоко, топінг, вершки кондитерські',
          },
        ],
      },
      {
        subcategory: 'Безалкогольні коктейлі',
        items: [
          {
            id: 1,
            title: 'mojito 250мл',
            price: '140 грн',
            text: `
Моршинська,
М'ята,
Лайм,
коричневий цукор`,
            src: require('../img/Mojito.jpg'),
            description: ``,
          },
          {
            id: 6,
            title: 'Апероль спрітц б/а 250мл',
            price: '140 грн',
            src: require('../img/peachAper.jpg'),
            text: 'Апероль сироп, тонік, апельсин',
          },
//           {
//             id: 2,
//             title: 'mimosa 180мл',
//             price: '140 грн',
//             text: `фреш апельсину,
// Тонік`,
//             src: require('../img/mimoza.jpg'),
//             description: ``,
//           },
          {
            id: 3,
            title: 'cucumber boom 300мл',
            price: '130 грн',
            text: `Тонік,
Огірок,
коричневий цукор`,
            src: require('../img/CucumberBoom.jpg'),
            description: ``,
          },
          {
            id: 4,
            title: 'spicy ginger 300мл',
            price: '135 грн',
            text: `Сироп кориця,
імбир,
Лайм,
Сік апельсин,
мінеральна вода`,
            src: require('../img/SpicyGinger.jpg'),
            description: ``,
          },
          {
            id: 5,
            title: 'Пінья Колада 300мл',
            price: '155 грн',
            src: require('../img/kolada.jpg'),
            text: 'сироп кокосовий, сік ананасовий, вершки, вишня',
          },
        ],
      },
      {
        subcategory: 'Шоти',
        items: [
          {
            id: 1,
            title: 'Аравіка 50мл',
            price: '165 грн',
            text: 'сироп гренадін, лікер кавовий, фреш лимон, текіла',
            src: require('../img/aravika.jpg'),
            description: ``,
          },
          {
            id: 2,
            title: 'Хмари 50мл',
            price: '165 грн',
            text: 'самбука, текіла, абсент, лікер блю кюрасао, Бейліз',
            src: require('../img/oblaka.jpg'),
            description: ``,
          },
          {
            id: 3,
            title: 'Пухлина мозку 50мл',
            price: '165 грн',
            text: 'самбука, Мартіні Б’янко, Бейліз, сироп гренадін',
            src: require('../img/mozg.jpg'),
            description: ``,
          },
          {
            id: 4,
            title: 'Медуза 50мл',
            price: '165 грн',
            text: 'лікер кокосовий, лікер апельсиновий, ром золотий, Бейліз, лікер блю кюрасао',
            src: require('../img/meduza.jpg'),
            description: ``,
          },

          {
            id: 5,
            title: 'Санрайз 50мл',
            price: '165 грн',
            text: 'сироп гренадін, сік апельсиновий, текіла',
            src: require('../img/sunrise.jpg'),
            description: ``,
          },
          {
            id: 6,
            title: 'Фрамбі 50мл',
            price: '165 грн',
            text: 'сироп вишня, ром золотий, вишня',
            src: require('../img/frambi.jpg'),
            description: ``,
          },
          // {
          //   id: 7,
          //   title: 'Драцена 50мл',
          //   price: '165 грн',
          //   text: 'лікер касіс, горілка, лимон',
          //   src: require('../img/dracena.jpg'),
          //   description: ``,
          // },
          {
            id: 8,
            title: 'Зелений мексиканець 50мл',
            price: '165 грн',
            text: 'текіла, сік лимонний, сироп банановий',
            src: require('../img/meks.jpg'),
            description: ``,
          },
        ],
      },
    ],
  },
  {
    category: 'Банкетне меню',
    subcategories: [
      {
        subcategory: 'Меню',
        items: [
          {
            id: 18,
            title: 'Рибне філе-меню 200г',
            price: '460 грн',
            src: require('../img/ribneFile.jpg'),
            text: 'Лосось, тунець, масляна, пряна олія, червона ікра, лимон',
            description: `Елегантне поєднання соковитого лосося, ніжного тунця та масляної рибки, доповнене яскравою червоною ікрою та пікантними каперсами. Все це підкреслюється ароматною пряною олією, яка додає глибини смаку та робить страву ще більш вишуканою.`,
            zvd: 'room',
          },
          {
            id: 19,
            title: 'сирне плато 240г',
            price: '375 грн',
            src: require('../img/tarilkaGurmana.webp'),
            text: `Пармезан, дор-блю, камамбер, гауда, мед, кедрові горіхи, мигдалеві пластівці, полуниця`,
            description: ``,
            zvd: 'room',
            energy: true,
          },
          {
            id: 20,
            title: 'Мʼясна класика 220г',
            price: '385 грн',
            src: require('../img/myasnsTarilka.webp'),
            text: 'Пепероні, балик, ростбіф, прошутто, ніжний хрін, маслини',
            description: `Асорті з баликом, ростбіфом, пепероні та прошуто, доповнене маслинами та соусом з хріну та вершків. Це смачне поєднання м'ясних делікатесів з пікантним соусом, що підкреслює їх смак.`,
            zvd: 'room',
          },
          {
            id: 21,
            title: 'Салат з пряним лососем 240г',
            price: '370 грн',
            src: require('../img/salatLosos.jpg'),
            text: 'Мікс салату, пряний лосось, огірок, черрі, заправка салатна, горіх кедровий, лимон',
            description: `Салат зі шматочками пряного лосося, свіжими овочами та міксом салатного листя. Доповнений пармезаном, кедровими горіхами та лимоном для балансу смаку`,
            zvd: 'room',
            energy: true,
          },
          {
            id: 1,
            title: 'Асорті солінь 400г',
            price: '370 грн',
            src: require('../img/asortiSolin.webp'),
            text: 'Мариновані огірки, помідори, гриби, цибуля',
            description:
              'Асорті хрустких солінь: корнішони, соковиті томати чері, пікантні шампіньйони та пряна маринована цибуля – ідеальна закуска з яскравим смаком',
            zvd: 'room',
          },
          {
            id: 2,
            title: 'Овочевий мікс 300г',
            price: '160 грн',
            src: require('../img/ovocheviyMiks.webp'),
            text: 'Помідори, огірки, перець',
            description: `хрусткі огірки, соковиті помідори та солодкий болгарський перець – свіжість і натуральний смак у кожному шматочку`,
            zvd: 'room',
          },
          {
            id: 3,
            title: `Олів'є з лососем 220г`,
            price: '320 грн',
            src: require('../img/oliveZLososem.webp'),
            text: 'Пряний лосось, картопля, морква, яйця курячі, огірок свіжий, майонез, соєвий соус, лимон, червона ікра',
            description: `Ніжний пряний лосось, червона ікра, відварна картопля, морква, курячі яйця, хрусткий свіжий огірок та легкий майонез із пікантною ноткою соєвого соусу і лимона. Класичний салат у новій вишуканій інтерпретації`,
            zvd: 'room',
          },
          {
            id: 4,
            title: 'Брускета з ікрою 60г',
            price: '150 грн',
            src: require('../img/brusketaZikroy.webp'),
            text: 'Чіабатта, червона ікра, вершковий сир, мікрогрін',
            description: `Ніжний вершковий сир на підрум’яненій чіабатті, доповнений вишуканою червоною ікрою. Мінімалізм у найкращому виконанні`,
            zvd: 'room',
          },
          {
            id: 5,
            title: 'Канапе з сиром та виноградом 300г',
            price: '370 грн',
            src: require('../img/kanapeZsiromTaVinogradom.webp'),
            text: 'Виноград, балик, сир камамбер',
            description: `Вишукане поєднання ніжного камамбера, соковитого винограду та ароматного балику – ідеальна гра текстур і смаків. Подається сетом із 10 штук.`,
            zvd: 'room',
          },
          {
            id: 6,
            title: 'Канапе з оливками і гарганзолою 260г',
            price: '340 грн',
            src: require('../img/kanapeZSiromTaGarganzolou.webp'),
            text: 'Оливка, груша, гарганзола',
            description: `Пікантна горгонзола, соковита груша та оливка – гармонійне поєднання ніжності, солоності та легкої фруктової солодкавості. Подається сетом із 10 штук.`,
            zvd: 'room',
          },
          {
            id: 7,
            title: 'Тарталетка з ікрою 40г',
            price: '149 грн',
            src: require('../img/tartaletkaIkra.webp'),
            text: 'Тарталетка, вершковий сир, червона ікра, мікрогрін',
            description: `Вишукана червона ікра на ніжному вершковому сирі та свіжий мікрогрін — елегантна закуска, що поєднує багатство смаків.`,
            zvd: 'room',
          },
          {
            id: 8,
            title: 'Тарталетка з білими грибами 40г',
            price: '85 грн',
            src: require('../img/tartaletkaGribi.webp'),
            text: 'Тарталетка, вершковий сир, білі гриби, кріп, мікрогрін',
            description: `Хрустка основа, ніжний вершковий сир, аромати білих грибів, свіжий кріп та мікрогрін – смачна та елегантна закуска, що розкриває глибину лісових смаків`,
            zvd: 'room',
          },
          {
            id: 9,
            title: 'Ципля табака 100г (від 500г)',
            price: '90 грн',
            src: require('../img/ciplyaTabaka.webp'),
            text: 'Тушка ципляти, маринад, апельсин, соєвий соус, мікрогрін',
            description: `Соковита тушка курчати, запечена в ароматному маринаді з апельсином та соєвим соусом, подається з мікрогріном. Ідеальна комбінація смаків і текстур`,
            zvd: 'room',
          },
          // {
          //   id: 10,
          //   title: 'Каре телятини з грибним соусом 100г (від 200г)',
          //   price: '160 грн',
          //   src: require('../img/kareTrlyatini.webp'),
          //   text: 'Каре телятини, часник, розмарин, чебрець, соус із білих грибів',
          //   description: `Ніжне каре телятини, приготоване з ароматним часником, розмарином і чебрецем, доповнене соусом із білих грибів — справжня насолода для гурманів`,
          //   zvd: 'room',
          // },
          {
            id: 11,
            title: 'Філе індички з соусом діжон 100г (від 200г)',
            price: '130 грн',
            src: require('../img/fileIndichki.webp'),
            text: 'Філе індички сусід, часник, італійські трави, соус діжон, мікрогрін',
            description: `Ніжне філе індички, приготоване з часником та італійськими травами, подається з пікантним соусом діжон і свіжим мікрогріном — смачно і елегантно`,
            zvd: 'room',
          },
          {
            id: 12,
            title: 'Стейк із свинини з часниковим соусом 100г (від 200г)',
            price: '160 грн',
            src: require('../img/stakeSvinini.webp'),
            text: 'Свинячий ошийок, розмарин, соус часниковий, мікрогрін',
            description: `Соковитий свинячий ошийок, приготований з розмарином, подається з ароматним часниковим соусом і свіжим мікрогріном — вишуканий смак у кожному шматочку`,
            zvd: 'room',
          },
          {
            id: 13,
            title: 'Лосось запечений 280г',
            price: '490 грн',
            src: require('../img/lososZapecheniy.webp'),
            text: 'Лосось, вершки, пармезан, помідори чері, мікрогрін',
            description: `Ніжний лосось, запечений з вершками та пармезаном, доповнений соковитими помідорами чері і свіжим мікрогріном — смачна та елегантна страва для справжніх гурманів`,
            zvd: 'room',
          },
          {
            id: 14,
            title: 'Рататуй 400г',
            price: '300 грн',
            src: require('../img/ratatuy.webp'),
            text: 'Баклажан, кабачок, помідор, цибуля ріпчаста, перець болгарський, італійські трави, базилік',
            description: `Ароматне поєднання баклажанів, кабачків, помідорів, ріпчастої цибулі, болгарського перцю, збагачене італійськими травами та свіжим базиліком — класична овочева страва з яскравим смаком`,
            zvd: 'room',
          },
          {
            id: 15,
            title: 'Хрустка картопля з пряними травами 400г/100г',
            price: '160 грн',
            src: require('../img/kartoplyaZTravami.webp'),
            text: 'Картопля, сухарі, італійські трави, часник, олія',
            description: `Золотиста картопля, обваляна в сухарях і ароматних італійських травах, з нотками часнику та олії — ідеальна закуска з хрусткою текстурою і багатим смаком`,
            zvd: 'room',
          },
          {
            id: 16,
            title: 'Паштет з курячої печінки 150г',
            price: '180 грн',
            src: require('../img/pashtetKurPech.webp'),
            text: 'Куряча печінка, вершки, часник, вишневий соус, мигдальні пластівці, мікрогрін, чіабатта',
            description: `Ніжна куряча печінка, збагачена вершками та часником, подається з вишневим соусом, мигдальними пластівцями, мікрогріном і підрум’яненою чіабаттою — смачна і вишукана закуска`,
            zvd: 'room',
          },
        ],
      },
    ],
  },
];
